import React, { useState, useEffect, useRef, useMemo } from 'react'
import { toast } from 'react-toastify'
import {
  FiKey,
  FiCpu,
  FiMail,
  FiBookOpen,
  FiShield,
  FiCheckCircle,
  FiCopy,
  FiTrash2,
  FiRefreshCw,
  FiSend,
  FiPlus,
  FiX,
  FiEye,
  FiEyeOff,
  FiMessageSquare,
  FiPower,
  FiSearch,
  FiEdit2,
  FiServer,
  FiLock,
  FiSliders,
  FiFilter,
  FiCalendar,
  FiFileText,
  FiArrowLeft,
} from 'react-icons/fi'
import { BsStars, BsInfoCircleFill } from 'react-icons/bs'
import { MdDarkMode, MdLightMode, MdSettings } from 'react-icons/md'
import { FaChevronUp, FaFileContract } from 'react-icons/fa6'
import { FaGlobeAmericas } from 'react-icons/fa'
import { TbDoorExit } from 'react-icons/tb'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { useCustomTheme } from '../../context/Theme/ThemeContextData'
import ModalUserSettings from '../../components/Modals/ModalUserSettings'
import ModalWelcomeUpdate from '../../components/Modals/ModalWelcomeUpdate'
import api from '../../services/axios'
import { carregarDistribuidores } from '../../services/dists'
import gisaAvatar from '../../assets/gid-ia-icon.svg'
import { GidIaIcon } from '../../components/GisaAssistant/GidIaIcon'
import {
  HubContainer,
  HubLayout,
  HubSidebar,
  SidebarBackBtn,
  SidebarBrand,
  SidebarNavList,
  SidebarNavItem,
  SidebarUserFooter,
  HubUserCard,
  HubUserDropdown,
  RoleBadge,
  HubMainArea,
  DocNoticeBanner,
  SectionHeaderBar,
  SurfaceCard,
  DataTableWrapper,
  StyledTable,
  MethodBadge,
  UsageProgressWrapper,
  CipherBadge,
  StatusTag,
  ActionBtn,
  ModalOverlay,
  ModalCard,
  ModalHeader,
  ModalBody,
  ModalFooter,
  SubModalTriggerCard,
  MethodTabsBar,
  MethodTabBtn,
  FormRow,
  FieldGroup,
  StyledInput,
  StyledSelect,
  RouteSelectorBox,
  RouteItemLabel,
  SecretKeyCreatedBox,
  GisaChatCard,
  ChatBubble,
  KpiMiniGrid,
  CcChipList,
  DocSectionBlock,
  DocsSubTabsBar,
  DocsSubTabBtn,
  DocsCardsGrid,
  PulseIndicator,
} from './styles'

interface CatalogRouteItem {
  id: string
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'ALL'
  path: string
  category: 'consulta' | 'publicacao' | 'admin'
  module: string
  label: string
  description: string
  paramsDoc?: string
  examplePayloadOrQuery?: string
}

interface AiProviderCatalogItem {
  id: string
  name: string
  models: Array<{ id: string; label: string }>
}

interface ReportCatalogItem {
  id: string
  group?: string
  title: string
  description: string
}

interface DistributorCatalogItem {
  id: number
  name: string
  uf: string
  cnpj: string
}

interface ApiKeyRecord {
  id: number
  userId: number
  name: string
  keyPrefix: string
  roleAtCreation: string
  allowedRoutes: string[]
  isActive: boolean
  expiresAt: string | null
  lastUsedAt: string | null
  usageCount: number
  maxRequests: number
  createdAt: string
  ownerName: string
  ownerRole: string
}

interface AiKeyRecord {
  id: number
  name: string
  provider: string
  model: string
  maskedKey: string
  encryptedPreview: string
  encryptionAlgorithm: string
  isActive: boolean
  updatedAt: string
}

interface GisaTrainingRecord {
  id: number
  createdBy: number
  createdByName: string
  triggerPhrase: string
  keywords: string
  targetAction: string
  entityMapping: string
  expectedBehavior: string
  status: 'PENDENTE_TREINO' | 'TREINADO'
  hitCount: number
  isActive: boolean
  createdAt: string
  updatedAt: string
}

interface GisaUserShortcutRecord {
  id: number
  userId: number
  command: string
  label: string
  promptTemplate: string
  defaultAction: string
  defaultPeriod: 'mes_atual' | '3_meses' | '6_meses' | 'anual'
  defaultDistIds: number[] | 'ALL'
  pinToBar: boolean
  isActive: boolean
  updatedAt: string
}

interface EmailScheduleRecord {
  id: number
  userId: number
  name: string
  recipientEmail: string
  ccEmails: string[]
  reportTypes: string[]
  exportFormats: Array<'PDF' | 'CSV' | 'EXCEL'>
  distributorIds: number[] | 'ALL'
  periodWindow: 'mes_atual' | '3_meses' | '6_meses' | 'anual'
  frequency: 'diario' | 'semanal' | 'mensal'
  sendTime: string
  isActive: boolean
  lastSentAt: string | null
  updatedAt: string
  ownerName?: string
}

interface GisaSummaryData {
  generatedAt: string
  userRole: string
  userName: string
  kpis: {
    totalDistribuidoresAtivos: number
    distribuidoresComEnvioRecente: number
    distribuidoresPendentes7Dias: number
    totalClientesAtivos: number
    totalProdutosHomologados: number
    totalProdutosInvalidosPendentes: number
    selloutUltimos30DiasValor: number
    selloutUltimos30DiasQtd: number
    estoqueRegistrosRecentes: number
  }
  topDistribuidores: Array<{
    id: number
    nome: string
    regional: string
    ultimoEnvio: string | null
  }>
  systemCapabilities: Array<{
    modulo: string
    descricao: string
    disponivelParaPerfil: boolean
  }>
}

interface ChatMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  timestamp: string
  modelLabel?: string
}

export type HubTabId = 'keys' | 'gisa' | 'email' | 'smtp' | 'docs'

interface IntegrationsHubProps {
  initialTab?: HubTabId
  onBackToPanel?: () => void
  onOpenUserSettings?: () => void
  onOpenWelcome?: () => void
}

export function IntegrationsHub({
  initialTab = 'keys',
  onBackToPanel,
  onOpenUserSettings,
  onOpenWelcome,
}: IntegrationsHubProps) {
  const { user, signOut } = useAuth()
  const { theme, toggleTheme } = useCustomTheme()
  const navigate = useNavigate()
  const nickname = user?.nickname || 'Usuário'
  const userRole = String(user?.role || '')
    .trim()
    .toLowerCase()
  const isAdmin = userRole === 'administrador'
  const isSuporte = userRole === 'suporte'
  const isAllowedRole = ['administrador', 'suporte', 'conferente'].includes(userRole)

  const [activeTab, setActiveTab] = useState<HubTabId>(initialTab)
  const [userMenuOpen, setUserMenuOpen] = useState(false)
  const [localSettingsOpen, setLocalSettingsOpen] = useState(false)
  const [localWelcomeOpen, setLocalWelcomeOpen] = useState(false)
  const userFooterRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const handleOutside = (ev: MouseEvent) => {
      if (
        userMenuOpen &&
        userFooterRef.current &&
        !userFooterRef.current.contains(ev.target as Node)
      ) {
        setUserMenuOpen(false)
      }
    }
    const handleEsc = (ev: KeyboardEvent) => {
      if (ev.key === 'Escape') setUserMenuOpen(false)
    }
    document.addEventListener('mousedown', handleOutside)
    document.addEventListener('keydown', handleEsc)
    return () => {
      document.removeEventListener('mousedown', handleOutside)
      document.removeEventListener('keydown', handleEsc)
    }
  }, [userMenuOpen])

  const handleBackToPanel = () => {
    if (onBackToPanel) {
      onBackToPanel()
    } else {
      navigate('/painel')
    }
  }
  const [showDocBanner, setShowDocBanner] = useState<boolean>(() => {
    return localStorage.getItem('@GID:hide_integrations_doc_banner_v2') !== 'true'
  })

  // Catálogos carregados do Back-End
  const [routesCatalog, setRoutesCatalog] = useState<CatalogRouteItem[]>([])
  const [rolePolicyDesc, setRolePolicyDesc] = useState<string>('')
  const [canAddCustomRoute, setCanAddCustomRoute] = useState<boolean>(false)
  const [maxRequestsPerKey, setMaxRequestsPerKey] = useState<number>(100)
  const [aiProviders, setAiProviders] = useState<AiProviderCatalogItem[]>([])
  const [reportsCatalog, setReportsCatalog] = useState<ReportCatalogItem[]>([])
  const [distributorsCatalog, setDistributorsCatalog] = useState<DistributorCatalogItem[]>([])

  // =========================================================================
  // 1. ESTADOS: API KEYS (TABELA + MODAL + SUB-MODAL DE ROTAS)
  // =========================================================================
  const [apiKeys, setApiKeys] = useState<ApiKeyRecord[]>([])
  const [loadingKeys, setLoadingKeys] = useState(false)
  const [newlyCreatedKey, setNewlyCreatedKey] = useState<string | null>(null)

  // Modal Criar / Editar API Key
  const [apiKeyModalOpen, setApiKeyModalOpen] = useState(false)
  const [editingApiKeyId, setEditingApiKeyId] = useState<number | null>(null)
  const [keyName, setKeyName] = useState('')
  const [expiresInDays, setExpiresInDays] = useState<string>('0')
  const [selectedRoutes, setSelectedRoutes] = useState<string[]>([])
  const [savingApiKey, setSavingApiKey] = useState(false)

  // Sub-Modal ("Modal do Modal") para selecionar rotas por método (GET, POST, PUT, DELETE)
  const [routesSubModalOpen, setRoutesSubModalOpen] = useState(false)
  const [methodTab, setMethodTab] = useState<'ALL_METHODS' | 'GET' | 'POST' | 'PUT' | 'DELETE' | 'ALL'>('ALL_METHODS')
  const [routeSearch, setRouteSearch] = useState('')
  const [customRouteMethod, setCustomRouteMethod] = useState<'GET' | 'POST' | 'PUT' | 'DELETE' | 'ALL'>('GET')
  const [customRoutePath, setCustomRoutePath] = useState('')

  // =========================================================================
  // 2. ESTADOS: CHAT GISA & TABELA DE CHAVES IA CRIPTOGRAFADAS + MODAL
  // =========================================================================
  const [aiKeys, setAiKeys] = useState<AiKeyRecord[]>([])
  const [gisaUnlocked, setGisaUnlocked] = useState(false)
  const [activeAiProvider, setActiveAiProvider] = useState('gemini')
  const [activeAiModel, setActiveAiModel] = useState('gemini-2.5-flash')

  // Modal Adicionar / Editar Chave de IA
  const [aiModalOpen, setAiModalOpen] = useState(false)
  const [editingAiKeyId, setEditingAiKeyId] = useState<number | null>(null)
  const [aiKeyName, setAiKeyName] = useState('')
  const [aiProvider, setAiProvider] = useState('gemini')
  const [aiModel, setAiModel] = useState('')
  const [customAiModel, setCustomAiModel] = useState('')
  const [aiApiKey, setAiApiKey] = useState('')
  const [aiKeyIsActive, setAiKeyIsActive] = useState(true)
  const [showAiKey, setShowAiKey] = useState(false)
  const [savingAi, setSavingAi] = useState(false)

  // Chat da GISA
  const [gisaSummary, setGisaSummary] = useState<GisaSummaryData | null>(null)
  const [chatMessages, setChatMessages] = useState<ChatMessage[]>([])
  const [chatInput, setChatInput] = useState('')
  const [sendingChat, setSendingChat] = useState(false)
  const messagesEndRef = useRef<HTMLDivElement>(null)

  // Treinamento Compartilhado da GISA (Histórico Capturado & Regras Ensinadas)
  const [gisaTrainings, setGisaTrainings] = useState<GisaTrainingRecord[]>([])
  const [trainingFilterTab, setTrainingFilterTab] = useState<'ALL' | 'PENDENTE_TREINO' | 'TREINADO'>('ALL')
  const [trainingModalOpen, setTrainingModalOpen] = useState(false)
  const [editingTrainingId, setEditingTrainingId] = useState<number | null>(null)
  const [trainingTriggerPhrase, setTrainingTriggerPhrase] = useState('')
  const [trainingKeywords, setTrainingKeywords] = useState('')
  const [trainingTargetAction, setTrainingTargetAction] = useState<string>('sellout')
  const [trainingEntityMapping, setTrainingEntityMapping] = useState('')
  const [trainingExpectedBehavior, setTrainingExpectedBehavior] = useState('')
  const [trainingIsActive, setTrainingIsActive] = useState(true)
  const [savingTraining, setSavingTraining] = useState(false)

  // Atalhos & Padrões Pessoais da GISA (Isolados por Usuário)
  const [userShortcuts, setUserShortcuts] = useState<GisaUserShortcutRecord[]>([])
  const [shortcutModalOpen, setShortcutModalOpen] = useState(false)
  const [editingShortcutId, setEditingShortcutId] = useState<number | null>(null)
  const [shortcutCommand, setShortcutCommand] = useState('')
  const [shortcutLabel, setShortcutLabel] = useState('')
  const [shortcutPromptTemplate, setShortcutPromptTemplate] = useState('')
  const [shortcutDefaultAction, setShortcutDefaultAction] = useState<string>('chat')
  const [shortcutDefaultPeriod, setShortcutDefaultPeriod] = useState<'mes_atual' | '3_meses' | '6_meses' | 'anual'>('anual')
  const [shortcutPinToBar, setShortcutPinToBar] = useState(true)
  const [savingShortcut, setSavingShortcut] = useState(false)

  // =========================================================================
  // 3. ESTADOS: RELATÓRIO DIÁRIO / PROGRAMADO (TABELA + MODAL + 2 SUB-MODAIS)
  // =========================================================================
  const [schedules, setSchedules] = useState<EmailScheduleRecord[]>([])
  const [emailModalOpen, setEmailModalOpen] = useState(false)
  const [editingScheduleId, setEditingScheduleId] = useState<number | null>(null)
  const [scheduleName, setScheduleName] = useState('')
  const [recipientEmail, setRecipientEmail] = useState(user?.email || '')
  const [ccEmails, setCcEmails] = useState<string[]>([])
  const [ccInput, setCcInput] = useState('')
  const [selectedReports, setSelectedReports] = useState<string[]>([
    'tela_geral',
    'resumo_executivo',
  ])
  const [exportFormats, setExportFormats] = useState<Array<'PDF' | 'CSV' | 'EXCEL'>>(['PDF'])
  const [selectedDistributorIds, setSelectedDistributorIds] = useState<number[] | 'ALL'>('ALL')
  const [periodWindow, setPeriodWindow] = useState<'mes_atual' | '3_meses' | '6_meses' | 'anual'>('mes_atual')
  const [frequency, setFrequency] = useState<'diario' | 'semanal' | 'mensal'>('diario')
  const [sendTime, setSendTime] = useState('08:00')
  const [scheduleActive, setScheduleActive] = useState(true)
  const [savingReport, setSavingReport] = useState(false)
  const [testingScheduleId, setTestingScheduleId] = useState<number | null>(null)

  // Sub-Modal A: Escolher Telas, Relatórios e Formato (PDF, CSV, EXCEL)
  const [reportsSubModalOpen, setReportsSubModalOpen] = useState(false)
  // Sub-Modal B: Escolher Distribuidores e Período (Por Mês, 3 Meses, 6 Meses, Anual)
  const [distsSubModalOpen, setDistsSubModalOpen] = useState(false)
  const [distSearch, setDistSearch] = useState('')

  // =========================================================================
  // 4. ESTADOS: SERVIDOR SMTP CRIPTOGRAFADO EM BANCO (ADMIN)
  // =========================================================================
  const [smtpHost, setSmtpHost] = useState('')
  const [smtpPort, setSmtpPort] = useState(587)
  const [smtpUser, setSmtpUser] = useState('')
  const [smtpPass, setSmtpPass] = useState('')
  const [smtpFrom, setSmtpFrom] = useState('')
  const [smtpSecure, setSmtpSecure] = useState(false)
  const [smtpHasPass, setSmtpHasPass] = useState(false)
  const [smtpConfigured, setSmtpConfigured] = useState(false)
  const [smtpEncryptedPreview, setSmtpEncryptedPreview] = useState('')
  const [smtpUpdatedAt, setSmtpUpdatedAt] = useState<string | null>(null)
  const [smtpModalOpen, setSmtpModalOpen] = useState(false)
  const [showSmtpPass, setShowSmtpPass] = useState(false)
  const [smtpTestEmail, setSmtpTestEmail] = useState(user?.email || '')
  const [savingSmtp, setSavingSmtp] = useState(false)
  const [testingSmtp, setTestingSmtp] = useState(false)

  // =========================================================================
  // 5. ESTADOS: DOCS (ABAS E FILTRO DE ROTAS NA DOCUMENTAÇÃO)
  // =========================================================================
  const [docSubTab, setDocSubTab] = useState<
    'api_auth' | 'routes' | 'gisa_ai' | 'training_shortcuts' | 'reports_excel' | 'smtp_admin'
  >('gisa_ai')
  const [docMethodFilter, setDocMethodFilter] = useState<'ALL' | 'GET' | 'POST' | 'PUT' | 'DELETE'>('ALL')
  const [docSearch, setDocSearch] = useState('')

  useEffect(() => {
    if (isAllowedRole) {
      carregarTudo()
    }
  }, [isAllowedRole])

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' })
  }, [chatMessages])

  const normalizarListaDistribuidores = (rawList: any[]): DistributorCatalogItem[] => {
    if (!Array.isArray(rawList)) return []
    return rawList
      .filter((d) => {
        if (!d || !d.id) return false
        const st = String(d.status ?? '1').trim().toLowerCase()
        return st !== '0' && st !== 'inativo' && st !== 'false'
      })
      .map((d) => ({
        id: Number(d.id),
        name: String(d.fantasy_name || d.name || d.nome || `Distribuidor #${d.id}`),
        uf: String(d.regional || d.uf || ''),
        cnpj: String(d.cnpj || ''),
      }))
      .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
  }

  const garantirDistribuidoresCarregados = async (forceRefresh = false) => {
    try {
      const distsFromService = await carregarDistribuidores(forceRefresh)
      const normalized = normalizarListaDistribuidores(distsFromService)
      if (normalized.length > 0) {
        setDistributorsCatalog(normalized)
      }
    } catch (e) {
      console.error('Erro ao buscar distribuidores via /dist:', e)
    }
  }

  const carregarTudo = async () => {
    try {
      setLoadingKeys(true)
      const requests: Promise<any>[] = [
        api.get('/integracoes/catalogo'),
        api.get('/integracoes/api-keys'),
        api.get('/integracoes/ia-config'),
        api.get('/integracoes/relatorio-diario'),
        carregarDistribuidores().catch(() => []),
        api.get('/integracoes/gisa/treinamentos').catch(() => ({ data: { trainings: [] } })),
        api.get('/integracoes/gisa/atalhos').catch(() => ({ data: { shortcuts: [] } })),
      ]
      if (isAdmin) {
        requests.push(api.get('/admin/config/smtp').catch(() => ({ data: null })))
      }

      const [
        catRes,
        keysRes,
        aiRes,
        repRes,
        distsFromService,
        trainingsRes,
        shortcutsRes,
        smtpRes,
      ] = await Promise.all(requests)

      if (catRes?.data) {
        const catRoutes: CatalogRouteItem[] = catRes.data.routesCatalog || []
        setRoutesCatalog(catRoutes)
        setRolePolicyDesc(catRes.data.rolePolicyDescription || '')
        setCanAddCustomRoute(Boolean(catRes.data.canAddCustomRoute))
        setMaxRequestsPerKey(Number(catRes.data.maxRequestsPerApiKey) || 100)
        setAiProviders(catRes.data.aiProvidersCatalog || [])
        setReportsCatalog(catRes.data.reportsCatalog || [])

        const fromServiceNormalized = normalizarListaDistribuidores(distsFromService || [])
        const fromCatNormalized = normalizarListaDistribuidores(
          catRes.data.distributorsCatalog || [],
        )
        setDistributorsCatalog(
          fromServiceNormalized.length > 0 ? fromServiceNormalized : fromCatNormalized,
        )
      } else if (Array.isArray(distsFromService) && distsFromService.length > 0) {
        setDistributorsCatalog(normalizarListaDistribuidores(distsFromService))
      }

      if (keysRes?.data?.keys) {
        setApiKeys(keysRes.data.keys)
      }

      if (aiRes?.data) {
        const list: AiKeyRecord[] = aiRes.data.aiKeys || []
        setAiKeys(list)
        const unlocked = Boolean(aiRes.data.gisaUnlocked)
        setGisaUnlocked(unlocked)
        if (aiRes.data.provider) setActiveAiProvider(aiRes.data.provider)
        if (aiRes.data.model) setActiveAiModel(aiRes.data.model)
        if (unlocked) {
          carregarResumoGisa(aiRes.data.provider, aiRes.data.model)
        }
      }

      if (repRes?.data) {
        setSchedules(repRes.data.schedules || [])
      }

      if (trainingsRes?.data?.trainings) {
        setGisaTrainings(trainingsRes.data.trainings)
      }

      if (shortcutsRes?.data?.shortcuts) {
        setUserShortcuts(shortcutsRes.data.shortcuts)
      }

      if (isAdmin && smtpRes?.data) {
        setSmtpHost(smtpRes.data.host || '')
        setSmtpPort(Number(smtpRes.data.port) || 587)
        setSmtpUser(smtpRes.data.user || '')
        setSmtpFrom(smtpRes.data.from || '')
        setSmtpSecure(Boolean(smtpRes.data.secure))
        setSmtpHasPass(Boolean(smtpRes.data.hasPass))
        setSmtpConfigured(Boolean(smtpRes.data.configured))
        setSmtpEncryptedPreview(smtpRes.data.encryptedPreview || '')
        setSmtpUpdatedAt(smtpRes.data.updatedAt || null)
        if (smtpRes.data.user && !smtpTestEmail) {
          setSmtpTestEmail(smtpRes.data.user)
        }
      }
    } catch (error) {
      console.error('Erro ao carregar Central de Integrações:', error)
      toast.error('Não foi possível carregar todos os dados da Central de Integrações.')
    } finally {
      setLoadingKeys(false)
    }
  }

  const carregarResumoGisa = async (prov?: string, mod?: string) => {
    try {
      const res = await api.get('/integracoes/gisa/resumo')
      if (res.data?.summary) {
        const s: GisaSummaryData = res.data.summary
        setGisaSummary(s)
        setChatMessages((prev) => {
          if (prev.length > 0) return prev
          const valorFormatado = Number(s.kpis.selloutUltimos30DiasValor || 0).toLocaleString(
            'pt-BR',
            { style: 'currency', currency: 'BRL' },
          )
          return [
            {
              id: 'welcome-gisa',
              role: 'assistant',
              timestamp: new Date().toLocaleTimeString('pt-BR', {
                hour: '2-digit',
                minute: '2-digit',
              }),
              modelLabel: `${(prov || res.data.provider || activeAiProvider).toUpperCase()} • ${
                mod || res.data.model || activeAiModel
              }`,
              content:
                `Olá, ${s.userName}! Eu sou a GISA, sua assistente de Inteligência Artificial integrada ao GID.\n\n` +
                `📊 Resumo em Tempo Real do Sistema:\n` +
                `• Distribuidores Ativos: ${s.kpis.totalDistribuidoresAtivos} (${s.kpis.distribuidoresComEnvioRecente} em dia nos últimos 7 dias | ${s.kpis.distribuidoresPendentes7Dias} pendentes)\n` +
                `• Sellout (Últimos 30 dias): ${valorFormatado}\n` +
                `• Carteira de Clientes (PDVs): ${s.kpis.totalClientesAtivos.toLocaleString('pt-BR')}\n` +
                `• Produtos Homologados: ${s.kpis.totalProdutosHomologados.toLocaleString('pt-BR')} (${s.kpis.totalProdutosInvalidosPendentes} inválidos pendentes)\n\n` +
                `Pergunte qualquer coisa sobre faturamento, estoque, regularidade de distribuidores, relatórios ou rotas de API!`,
            },
          ]
        })
      }
    } catch {
      // Silencioso caso ainda não haja chave ativa
    }
  }

  const fecharDocBanner = () => {
    localStorage.setItem('@GID:hide_integrations_doc_banner_v2', 'true')
    setShowDocBanner(false)
  }

  const copiarTexto = (texto: string, label: string) => {
    navigator.clipboard.writeText(texto)
    toast.success(`${label} copiado para a área de transferência!`)
  }

  // =========================================================================
  // HANDLERS: ABA 1 — API KEYS (TABELA + MODAL + SUB-MODAL DE ROTAS)
  // =========================================================================
  const abrirModalNovaApiKey = () => {
    setEditingApiKeyId(null)
    setKeyName('')
    setExpiresInDays('0')
    const defaultGets = routesCatalog
      .filter((r) => r.method === 'GET' && r.category === 'consulta')
      .slice(0, 5)
      .map((r) => r.id)
    setSelectedRoutes(defaultGets)
    setApiKeyModalOpen(true)
  }

  const abrirModalEditarApiKey = (key: ApiKeyRecord) => {
    setEditingApiKeyId(key.id)
    setKeyName(key.name)
    setExpiresInDays('0')
    setSelectedRoutes(key.allowedRoutes || [])
    setApiKeyModalOpen(true)
  }

  const toggleRouteSelection = (routeId: string) => {
    setSelectedRoutes((prev) =>
      prev.includes(routeId) ? prev.filter((id) => id !== routeId) : [...prev, routeId],
    )
  }

  const handleAddCustomAdminRoute = () => {
    if (!canAddCustomRoute) return
    const cleanPath = customRoutePath.trim()
    if (!cleanPath.startsWith('/')) {
      toast.warn('O caminho da rota customizada deve iniciar com "/" (ex: /dist ou /users).')
      return
    }
    const routeSignature = customRouteMethod === 'ALL' ? 'ALL *' : `${customRouteMethod} ${cleanPath}`
    if (!selectedRoutes.includes(routeSignature)) {
      setSelectedRoutes((prev) => [...prev, routeSignature])
    }
    setCustomRoutePath('')
    toast.success(`Rota ${routeSignature} vinculada!`)
  }

  const handleSalvarApiKeyModal = async () => {
    if (!keyName.trim() || keyName.trim().length < 3) {
      toast.warn('Informe um nome com pelo menos 3 caracteres para identificar a API Key.')
      return
    }
    if (selectedRoutes.length === 0) {
      toast.warn('Clique em "Selecionar Rotas" e escolha pelo menos 1 rota para vincular.')
      return
    }

    try {
      setSavingApiKey(true)
      if (editingApiKeyId) {
        await api.put(`/integracoes/api-keys/${editingApiKeyId}`, {
          name: keyName.trim(),
          allowedRoutes: selectedRoutes,
        })
        toast.success('API Key e rotas vinculadas atualizadas com sucesso!')
      } else {
        const res = await api.post('/integracoes/api-keys', {
          name: keyName.trim(),
          allowedRoutes: selectedRoutes,
          expiresInDays: Number(expiresInDays) > 0 ? Number(expiresInDays) : null,
        })
        setNewlyCreatedKey(res.data.apiKey)
        toast.success(res.data.message || 'API Key gerada com sucesso (Limite: 100 requisições)!')
      }
      setApiKeyModalOpen(false)
      const keysRes = await api.get('/integracoes/api-keys')
      if (keysRes.data?.keys) setApiKeys(keysRes.data.keys)
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao salvar API Key.')
    } finally {
      setSavingApiKey(false)
    }
  }

  const handleToggleKeyStatus = async (key: ApiKeyRecord) => {
    try {
      await api.put(`/integracoes/api-keys/${key.id}`, {
        isActive: !key.isActive,
      })
      toast.success(`API Key "${key.name}" ${!key.isActive ? 'ativada' : 'pausada'} com sucesso.`)
      const keysRes = await api.get('/integracoes/api-keys')
      if (keysRes.data?.keys) setApiKeys(keysRes.data.keys)
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao alterar status da API Key.')
    }
  }

  const handleDeleteApiKey = async (key: ApiKeyRecord) => {
    if (!window.confirm(`Deseja realmente revogar e excluir a API Key "${key.name}"?`)) {
      return
    }
    try {
      await api.delete(`/integracoes/api-keys/${key.id}`)
      toast.success('API Key revogada e excluída com sucesso.')
      setApiKeys((prev) => prev.filter((item) => item.id !== key.id))
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao excluir API Key.')
    }
  }

  // Abas de métodos HTTP permitidos no Sub-Modal de Rotas segundo o perfil
  const allowedMethodTabs = useMemo(() => {
    if (isAdmin) {
      return [
        { id: 'ALL_METHODS', label: 'Todas as Rotas' },
        { id: 'GET', label: 'GET (Consultas)' },
        { id: 'POST', label: 'POST (Envios / Filtros)' },
        { id: 'PUT', label: 'PUT (Atualizações)' },
        { id: 'DELETE', label: 'DEL (Exclusões)' },
        { id: 'ALL', label: 'Acesso Total (*)' },
      ] as const
    }
    return [
      { id: 'ALL_METHODS', label: 'Todas Permitidas' },
      { id: 'GET', label: 'GET (Consultas)' },
      { id: 'POST', label: isSuporte ? 'POST (Consultas & Publicações)' : 'POST (Consultas Analíticas)' },
    ] as const
  }, [isAdmin, isSuporte])

  const filteredRoutesForSubModal = useMemo(() => {
    return routesCatalog.filter((r) => {
      if (methodTab !== 'ALL_METHODS' && r.method !== methodTab) return false
      if (!routeSearch.trim()) return true
      const q = routeSearch.toLowerCase()
      return (
        r.path.toLowerCase().includes(q) ||
        r.label.toLowerCase().includes(q) ||
        r.module.toLowerCase().includes(q) ||
        r.description.toLowerCase().includes(q)
      )
    })
  }, [routesCatalog, methodTab, routeSearch])

  // =========================================================================
  // HANDLERS: ABA 2 — GISA IA (TABELA DE CHAVES CRIPTOGRAFADAS + MODAL + CHAT)
  // =========================================================================
  const abrirModalNovaChaveIa = () => {
    setEditingAiKeyId(null)
    setAiKeyName('')
    setAiProvider('gemini')
    setAiModel('')
    setCustomAiModel('')
    setAiApiKey('')
    setAiKeyIsActive(true)
    setShowAiKey(false)
    setAiModalOpen(true)
  }

  useEffect(() => {
    const applyAction = (payload: any) => {
      if (!payload) return
      if (payload.tab) {
        setActiveTab(payload.tab)
      }
      if (payload.openAiModal) {
        setActiveTab('gisa')
        abrirModalNovaChaveIa()
      }
      if (payload.openTrainingModal) {
        setActiveTab('gisa')
        carregarTreinamentosGisa()
        if (payload.initialPhrase) {
          setEditingTrainingId(payload.trainingId || null)
          setTrainingTriggerPhrase(payload.initialPhrase)
          setTrainingKeywords('')
          setTrainingTargetAction('sellout')
          setTrainingEntityMapping('')
          setTrainingExpectedBehavior('')
          setTrainingIsActive(true)
          setTrainingModalOpen(true)
        }
      }
      if (payload.openShortcutModal) {
        setActiveTab('gisa')
        abrirModalNovoAtalhoPessoal()
      }
    }

    try {
      const pendingRaw = sessionStorage.getItem('@GID:pending_integrations_action')
      if (pendingRaw) {
        sessionStorage.removeItem('@GID:pending_integrations_action')
        applyAction(JSON.parse(pendingRaw))
      }
    } catch {}

    const handleOpenTabEvent = (ev: any) => {
      applyAction(ev?.detail)
    }

    window.addEventListener('gid:open-integrations-tab', handleOpenTabEvent as EventListener)
    return () => {
      window.removeEventListener('gid:open-integrations-tab', handleOpenTabEvent as EventListener)
    }
  }, [])

  const abrirModalEditarChaveIa = (item: AiKeyRecord) => {
    setEditingAiKeyId(item.id)
    setAiKeyName(item.name)
    setAiProvider(item.provider)
    setAiModel(item.model)
    setCustomAiModel('')
    setAiApiKey('')
    setAiKeyIsActive(item.isActive)
    setShowAiKey(false)
    setAiModalOpen(true)
  }

  const handleSalvarChaveIaModal = async () => {
    const chosenModel = aiModel.trim()
    if (!chosenModel) {
      toast.warn('Digite o modelo da IA que deseja utilizar.')
      return
    }
    if (!editingAiKeyId && !aiApiKey.trim()) {
      toast.warn('Informe a API Key do provedor de IA para criptografar e salvar.')
      return
    }

    try {
      setSavingAi(true)
      const payload = {
        id: editingAiKeyId || undefined,
        name: aiKeyName.trim() || `Chave ${aiProvider.toUpperCase()}`,
        provider: aiProvider,
        model: chosenModel,
        apiKey: aiApiKey.trim() || undefined,
        isActive: aiKeyIsActive,
      }

      const res = editingAiKeyId
        ? await api.put(`/integracoes/ia-config/${editingAiKeyId}`, payload)
        : await api.post('/integracoes/ia-config', payload)

      toast.success(res.data.message || 'Chave de IA salva e criptografada com sucesso!')
      setAiModalOpen(false)
      window.dispatchEvent(new CustomEvent('gid:ai-config-updated'))

      const aiRes = await api.get('/integracoes/ia-config')
      if (aiRes.data) {
        setAiKeys(aiRes.data.aiKeys || [])
        setGisaUnlocked(Boolean(aiRes.data.gisaUnlocked))
        if (aiRes.data.provider) setActiveAiProvider(aiRes.data.provider)
        if (aiRes.data.model) setActiveAiModel(aiRes.data.model)
        if (aiRes.data.gisaUnlocked) {
          await carregarResumoGisa(aiRes.data.provider, aiRes.data.model)
        }
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao salvar chave de IA.')
    } finally {
      setSavingAi(false)
    }
  }

  const handleAtivarChaveIaNaTabela = async (item: AiKeyRecord) => {
    try {
      await api.put(`/integracoes/ia-config/${item.id}`, {
        name: item.name,
        provider: item.provider,
        model: item.model,
        isActive: true,
      })
      toast.success(`Chave "${item.name}" ativada para o Chat da GISA!`)
      window.dispatchEvent(new CustomEvent('gid:ai-config-updated'))
      const aiRes = await api.get('/integracoes/ia-config')
      if (aiRes.data) {
        setAiKeys(aiRes.data.aiKeys || [])
        setGisaUnlocked(Boolean(aiRes.data.gisaUnlocked))
        setActiveAiProvider(item.provider)
        setActiveAiModel(item.model)
        await carregarResumoGisa(item.provider, item.model)
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao ativar chave de IA.')
    }
  }

  const handleExcluirChaveIa = async (item: AiKeyRecord) => {
    if (!window.confirm(`Deseja excluir a chave de IA "${item.name}"?`)) return
    try {
      await api.delete(`/integracoes/ia-config/${item.id}`)
      toast.success('Chave de IA removida com sucesso.')
      window.dispatchEvent(new CustomEvent('gid:ai-config-updated'))
      const aiRes = await api.get('/integracoes/ia-config')
      if (aiRes.data) {
        setAiKeys(aiRes.data.aiKeys || [])
        setGisaUnlocked(Boolean(aiRes.data.gisaUnlocked))
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao remover chave de IA.')
    }
  }

  const handleSendGisaMessage = async (customPrompt?: string) => {
    const textToSend = (customPrompt ?? chatInput).trim()
    if (!textToSend || sendingChat) return

    const userMsg: ChatMessage = {
      id: `u-${Date.now()}`,
      role: 'user',
      content: textToSend,
      timestamp: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
    }

    const historyForApi = chatMessages.slice(-8).map((m) => ({
      role: m.role,
      content: m.content,
    }))

    setChatMessages((prev) => [...prev, userMsg])
    if (!customPrompt) setChatInput('')

    try {
      setSendingChat(true)
      const res = await api.post('/integracoes/gisa/chat', {
        message: textToSend,
        history: historyForApi,
      })

      const assistantMsg: ChatMessage = {
        id: `a-${Date.now()}`,
        role: 'assistant',
        content: res.data.reply,
        timestamp: new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' }),
        modelLabel: `${String(res.data.providerUsed || activeAiProvider).toUpperCase()} • ${
          res.data.modelUsed || activeAiModel
        }`,
      }
      setChatMessages((prev) => [...prev, assistantMsg])
      if (res.data?.autoCapturedTrainingId) {
        carregarTreinamentosGisa()
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao conversar com a GISA.')
    } finally {
      setSendingChat(false)
    }
  }

  // =========================================================================
  // HANDLERS: TREINAMENTO COMPARTILHADO DA GISA & ATALHOS PESSOAIS DO USUÁRIO
  // =========================================================================
  const carregarTreinamentosGisa = async () => {
    try {
      const res = await api.get('/integracoes/gisa/treinamentos')
      if (res.data?.trainings) {
        setGisaTrainings(res.data.trainings)
      }
    } catch {
      // Silencioso
    }
  }

  const carregarAtalhosPessoaisGisa = async () => {
    try {
      const res = await api.get('/integracoes/gisa/atalhos')
      if (res.data?.shortcuts) {
        setUserShortcuts(res.data.shortcuts)
      }
    } catch {
      // Silencioso
    }
  }

  const abrirModalNovoTreinamento = () => {
    setEditingTrainingId(null)
    setTrainingTriggerPhrase('')
    setTrainingKeywords('')
    setTrainingTargetAction('sellout')
    setTrainingEntityMapping('')
    setTrainingExpectedBehavior('')
    setTrainingIsActive(true)
    setTrainingModalOpen(true)
  }

  const abrirModalEnsinarTreinamento = (item: GisaTrainingRecord) => {
    setEditingTrainingId(item.id)
    setTrainingTriggerPhrase(item.triggerPhrase)
    setTrainingKeywords(item.keywords || '')
    setTrainingTargetAction(item.targetAction || 'sellout')
    setTrainingEntityMapping(item.entityMapping || '')
    setTrainingExpectedBehavior(item.expectedBehavior || '')
    setTrainingIsActive(item.isActive)
    setTrainingModalOpen(true)
  }

  const handleSalvarTreinamentoModal = async () => {
    if (!trainingTriggerPhrase.trim() || trainingTriggerPhrase.trim().length < 3) {
      toast.warn('Informe o que o usuário digita (Frase ou Pergunta Gatilho).')
      return
    }
    if (!trainingEntityMapping.trim() && !trainingExpectedBehavior.trim()) {
      toast.warn(
        'Defina o Distribuidor/Marca equivalente ou a instrução de como a GISA deve executar esta função.',
      )
      return
    }

    try {
      setSavingTraining(true)
      const payload = {
        id: editingTrainingId || undefined,
        triggerPhrase: trainingTriggerPhrase.trim(),
        keywords: trainingKeywords.trim(),
        targetAction: trainingTargetAction,
        entityMapping: trainingEntityMapping.trim(),
        expectedBehavior: trainingExpectedBehavior.trim(),
        isActive: trainingIsActive,
      }

      const res = editingTrainingId
        ? await api.put(`/integracoes/gisa/treinamentos/${editingTrainingId}`, payload)
        : await api.post('/integracoes/gisa/treinamentos', payload)

      toast.success(
        res.data?.message || 'Treinamento salvo e ativado na inteligência compartilhada da GISA!',
      )
      setTrainingModalOpen(false)
      await carregarTreinamentosGisa()
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao salvar treinamento da GISA.')
    } finally {
      setSavingTraining(false)
    }
  }

  const handleExcluirTreinamento = async (item: GisaTrainingRecord) => {
    if (
      !window.confirm(
        `Deseja remover o item de treinamento "${item.triggerPhrase.slice(0, 60)}"?`,
      )
    )
      return
    try {
      await api.delete(`/integracoes/gisa/treinamentos/${item.id}`)
      toast.success('Registro de treinamento removido.')
      await carregarTreinamentosGisa()
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao excluir treinamento.')
    }
  }

  const abrirModalNovoAtalhoPessoal = () => {
    setEditingShortcutId(null)
    setShortcutCommand('/meu-atalho')
    setShortcutLabel('⚡ Minha Consulta Rápida')
    setShortcutPromptTemplate(
      'Quero ver a evolução do sellout desde janeiro até o dia de hoje com análise executiva.',
    )
    setShortcutDefaultAction('chat')
    setShortcutDefaultPeriod('anual')
    setShortcutPinToBar(true)
    setShortcutModalOpen(true)
  }

  const abrirModalEditarAtalhoPessoal = (item: GisaUserShortcutRecord) => {
    setEditingShortcutId(item.id)
    setShortcutCommand(item.command)
    setShortcutLabel(item.label)
    setShortcutPromptTemplate(item.promptTemplate)
    setShortcutDefaultAction(item.defaultAction || 'chat')
    setShortcutDefaultPeriod(item.defaultPeriod || 'anual')
    setShortcutPinToBar(item.pinToBar)
    setShortcutModalOpen(true)
  }

  const handleSalvarAtalhoPessoalModal = async () => {
    if (!shortcutCommand.trim() || !shortcutLabel.trim() || !shortcutPromptTemplate.trim()) {
      toast.warn('Preencha o comando (/atalho), o nome do botão e o prompt padrão.')
      return
    }

    try {
      setSavingShortcut(true)
      const payload = {
        id: editingShortcutId || undefined,
        command: shortcutCommand.trim(),
        label: shortcutLabel.trim(),
        promptTemplate: shortcutPromptTemplate.trim(),
        defaultAction: shortcutDefaultAction,
        defaultPeriod: shortcutDefaultPeriod,
        pinToBar: shortcutPinToBar,
        isActive: true,
      }

      const res = editingShortcutId
        ? await api.put(`/integracoes/gisa/atalhos/${editingShortcutId}`, payload)
        : await api.post('/integracoes/gisa/atalhos', payload)

      toast.success(res.data?.message || 'Atalho pessoal salvo com sucesso!')
      setShortcutModalOpen(false)
      await carregarAtalhosPessoaisGisa()
      window.dispatchEvent(new CustomEvent('gid:gisa-shortcuts-updated'))
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao salvar atalho pessoal.')
    } finally {
      setSavingShortcut(false)
    }
  }

  const handleExcluirAtalhoPessoal = async (item: GisaUserShortcutRecord) => {
    if (!window.confirm(`Deseja remover seu atalho pessoal "${item.label}" (${item.command})?`))
      return
    try {
      await api.delete(`/integracoes/gisa/atalhos/${item.id}`)
      toast.success('Atalho pessoal removido.')
      await carregarAtalhosPessoaisGisa()
      window.dispatchEvent(new CustomEvent('gid:gisa-shortcuts-updated'))
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao remover atalho pessoal.')
    }
  }

  const filteredGisaTrainings = useMemo(() => {
    if (trainingFilterTab === 'ALL') return gisaTrainings
    return gisaTrainings.filter((t) => t.status === trainingFilterTab)
  }, [gisaTrainings, trainingFilterTab])

  // =========================================================================
  // HANDLERS: ABA 3 — RELATÓRIOS POR E-MAIL (TABELA + MODAL + 2 SUB-MODAIS)
  // =========================================================================
  const abrirModalNovoAgendamento = () => {
    setEditingScheduleId(null)
    setScheduleName('Relatório Executivo GID')
    setRecipientEmail(user?.email || '')
    setCcEmails([])
    setCcInput('')
    setSelectedReports(['tela_geral', 'resumo_executivo'])
    setExportFormats(['PDF'])
    setSelectedDistributorIds('ALL')
    setPeriodWindow('mes_atual')
    setFrequency('diario')
    setSendTime('08:00')
    setScheduleActive(true)
    setEmailModalOpen(true)
  }

  const abrirModalEditarAgendamento = (sched: EmailScheduleRecord) => {
    setEditingScheduleId(sched.id)
    setScheduleName(sched.name || 'Relatório Executivo GID')
    setRecipientEmail(sched.recipientEmail || '')
    setCcEmails(sched.ccEmails || [])
    setCcInput('')
    setSelectedReports(sched.reportTypes || ['resumo_executivo'])
    setExportFormats(sched.exportFormats?.length ? sched.exportFormats : ['PDF'])
    setSelectedDistributorIds(sched.distributorIds || 'ALL')
    setPeriodWindow(sched.periodWindow || 'mes_atual')
    setFrequency(sched.frequency || 'diario')
    setSendTime(sched.sendTime || '08:00')
    setScheduleActive(sched.isActive)
    setEmailModalOpen(true)
  }

  const handleAddCcEmail = () => {
    const raw = ccInput.trim().toLowerCase()
    if (!raw) return
    const parts = raw
      .split(/[,;\s]+/)
      .map((s) => s.trim())
      .filter(Boolean)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    const validNew: string[] = []
    for (const p of parts) {
      if (!emailRegex.test(p)) {
        toast.warn(`O endereço "${p}" não é um e-mail válido.`)
        return
      }
      if (!ccEmails.includes(p)) {
        validNew.push(p)
      }
    }
    setCcEmails((prev) => [...prev, ...validNew])
    setCcInput('')
  }

  const toggleReportType = (repId: string) => {
    setSelectedReports((prev) =>
      prev.includes(repId) ? prev.filter((id) => id !== repId) : [...prev, repId],
    )
  }

  const toggleExportFormat = (fmt: 'PDF' | 'CSV' | 'EXCEL') => {
    setExportFormats((prev) => {
      if (prev.includes(fmt)) {
        if (prev.length === 1) {
          toast.info('Mantenha pelo menos 1 formato selecionado (PDF, CSV ou EXCEL).')
          return prev
        }
        return prev.filter((item) => item !== fmt)
      }
      return [...prev, fmt]
    })
  }

  const toggleDistributorSelection = (distId: number) => {
    setSelectedDistributorIds((prev) => {
      const currentList =
        prev === 'ALL' ? distributorsCatalog.map((d) => d.id) : [...prev]
      if (currentList.includes(distId)) {
        const next = currentList.filter((id) => id !== distId)
        return next.length === 0 ? 'ALL' : next
      }
      const next = [...currentList, distId]
      return next.length >= distributorsCatalog.length ? 'ALL' : next
    })
  }

  const handleSalvarAgendamentoEmail = async () => {
    if (!recipientEmail.trim() || !recipientEmail.includes('@')) {
      toast.warn('Informe um e-mail destinatário principal válido.')
      return
    }
    if (selectedReports.length === 0) {
      toast.warn('Selecione pelo menos 1 tela ou relatório no seletor.')
      return
    }

    try {
      setSavingReport(true)
      const payload = {
        id: editingScheduleId || undefined,
        name: scheduleName.trim() || 'Relatório Executivo GID',
        recipientEmail: recipientEmail.trim(),
        ccEmails,
        reportTypes: selectedReports,
        exportFormats,
        distributorIds: selectedDistributorIds,
        periodWindow,
        frequency,
        sendTime,
        isActive: scheduleActive,
      }

      const res = editingScheduleId
        ? await api.put(`/integracoes/relatorio-diario/${editingScheduleId}`, payload)
        : await api.post('/integracoes/relatorio-diario', payload)

      toast.success(res.data.message || 'Agendamento de e-mail salvo com sucesso!')
      setEmailModalOpen(false)
      const repRes = await api.get('/integracoes/relatorio-diario')
      if (repRes.data?.schedules) setSchedules(repRes.data.schedules)
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao salvar agendamento de relatório.')
    } finally {
      setSavingReport(false)
    }
  }

  const handleDispararTesteDaTabela = async (sched: EmailScheduleRecord) => {
    try {
      setTestingScheduleId(sched.id)
      const res = await api.post('/integracoes/relatorio-diario/testar', {
        name: sched.name,
        recipientEmail: sched.recipientEmail,
        ccEmails: sched.ccEmails,
        reportTypes: sched.reportTypes,
        exportFormats: sched.exportFormats,
        distributorIds: sched.distributorIds,
        periodWindow: sched.periodWindow,
        frequency: sched.frequency,
        sendTime: sched.sendTime,
        isActive: sched.isActive,
      })
      toast.success(res.data.message || 'E-mail de relatório enviado com sucesso!')
    } catch (err: any) {
      toast.error(
        err.response?.data?.error ||
          'Erro ao disparar relatório. Verifique a configuração na aba Servidor SMTP.',
      )
    } finally {
      setTestingScheduleId(null)
    }
  }

  const handleExcluirAgendamentoEmail = async (sched: EmailScheduleRecord) => {
    if (!window.confirm(`Deseja excluir o agendamento "${sched.name}"?`)) return
    try {
      await api.delete(`/integracoes/relatorio-diario/${sched.id}`)
      toast.success('Agendamento removido com sucesso.')
      setSchedules((prev) => prev.filter((item) => item.id !== sched.id))
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao excluir agendamento.')
    }
  }

  // =========================================================================
  // HANDLERS: ABA 4 — SERVIDOR SMTP CRIPTOGRAFADO EM BANCO (ADMIN)
  // =========================================================================
  const handleSalvarSmtp = async () => {
    if (!smtpHost.trim() || !smtpUser.trim() || !smtpPort) {
      toast.warn('Preencha Host, Porta e Usuário/E-mail do servidor SMTP.')
      return
    }
    if (!smtpHasPass && !smtpPass.trim()) {
      toast.warn('A senha do SMTP é obrigatória para o primeiro cadastro.')
      return
    }

    try {
      setSavingSmtp(true)
      const portNum = Number(smtpPort)
      const isPort465 = portNum === 465
      const res = await api.post('/admin/config/smtp', {
        host: smtpHost.trim(),
        port: portNum,
        user: smtpUser.trim(),
        pass: smtpPass.trim() || undefined,
        from: smtpFrom.trim(),
        secure: isPort465 ? true : smtpSecure && portNum !== 587,
      })
      toast.success(res.data.message || 'Configuração SMTP salva e criptografada (AES-256-GCM)!')
      setSmtpPass('')
      setSmtpModalOpen(false)
      const smtpRes = await api.get('/admin/config/smtp')
      if (smtpRes.data) {
        setSmtpHost(smtpRes.data.host || '')
        setSmtpPort(Number(smtpRes.data.port) || 587)
        setSmtpUser(smtpRes.data.user || '')
        setSmtpFrom(smtpRes.data.from || '')
        setSmtpSecure(Boolean(smtpRes.data.secure))
        setSmtpHasPass(Boolean(smtpRes.data.hasPass))
        setSmtpConfigured(Boolean(smtpRes.data.configured))
        setSmtpEncryptedPreview(smtpRes.data.encryptedPreview || '')
        setSmtpUpdatedAt(smtpRes.data.updatedAt || null)
      }
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Erro ao salvar configurações SMTP.')
    } finally {
      setSavingSmtp(false)
    }
  }

  const handleTestarSmtp = async () => {
    if (!smtpHost.trim() || !smtpUser.trim() || !smtpPort) {
      toast.warn('Configure Host, Porta e Usuário antes de testar o disparo SMTP.')
      return
    }
    if (!smtpTestEmail.trim() || !smtpTestEmail.includes('@')) {
      toast.warn('Informe um e-mail de destino válido para o teste SMTP.')
      return
    }

    try {
      setTestingSmtp(true)
      const portNum = Number(smtpPort)
      const res = await api.post('/admin/config/smtp/testar', {
        host: smtpHost.trim(),
        port: portNum,
        user: smtpUser.trim(),
        pass: smtpPass.trim() || undefined,
        from: smtpFrom.trim(),
        secure: portNum === 465,
        emailDestino: smtpTestEmail.trim(),
      })
      toast.success(res.data.message || 'Conexão SMTP autenticada e e-mail enviado!')
    } catch (err: any) {
      toast.error(err.response?.data?.error || 'Falha ao testar servidor SMTP.')
    } finally {
      setTestingSmtp(false)
    }
  }

  // Helpers de formatação
  const formatPeriodLabel = (pw: string) => {
    if (pw === '3_meses') return '3 Meses'
    if (pw === '6_meses') return '6 Meses'
    if (pw === 'anual') return 'Anual (12m)'
    return 'Por Mês (Atual)'
  }

  const formatFrequencyLabel = (freq: string) => {
    if (freq === 'semanal') return 'Semanal (De semana em semana)'
    if (freq === 'mensal') return 'Mensal (De mês em mês)'
    return 'Recorrente (Diário)'
  }

  const currentProviderModels =
    aiProviders.find((p) => p.id === aiProvider)?.models ||
    aiProviders[0]?.models ||
    []

  const docsFilteredRoutes = useMemo(() => {
    return routesCatalog.filter((r) => {
      if (docMethodFilter !== 'ALL' && r.method !== docMethodFilter) return false
      if (!docSearch.trim()) return true
      const q = docSearch.toLowerCase()
      return (
        r.path.toLowerCase().includes(q) ||
        r.label.toLowerCase().includes(q) ||
        r.module.toLowerCase().includes(q) ||
        r.description.toLowerCase().includes(q)
      )
    })
  }, [routesCatalog, docMethodFilter, docSearch])

  if (!isAllowedRole) {
    return (
      <HubContainer>
        <HubMainArea>
          <SurfaceCard>
            <h3 style={{ color: '#ef4444', margin: 0 }}>Acesso Restrito</h3>
            <p style={{ margin: 0 }}>
              Esta central está disponível apenas para os perfis{' '}
              <strong>Administrador</strong>, <strong>Suporte</strong> e{' '}
              <strong>Conferente</strong>.
            </p>
          </SurfaceCard>
        </HubMainArea>
      </HubContainer>
    )
  }

  return (
    <HubContainer>
      <HubLayout>
        {/* =====================================================================
            MENU LATERAL (SIDEBAR) — SUBSTITUI O MENU DO TOPO
           ===================================================================== */}
        <HubSidebar>
          <SidebarBrand>
            <div className="brand-icon" style={{ background: 'transparent', padding: 0 }}>
              <GidIaIcon size={40} />
            </div>
            <div className="brand-text">
              <strong>Central GID IA</strong>
              <span>Integrações, IA & E-mails</span>
            </div>
          </SidebarBrand>

          <SidebarBackBtn
            type="button"
            onClick={handleBackToPanel}
            title="Voltar para o Painel Principal do GID"
          >
            <FiArrowLeft size={16} />
            <span>Voltar ao Painel Principal</span>
          </SidebarBackBtn>

          <SidebarNavList>
            <SidebarNavItem
              type="button"
              $active={activeTab === 'keys'}
              onClick={() => setActiveTab('keys')}
            >
              <div className="nav-icon">
                <FiKey />
              </div>
              <div className="nav-text">
                <span className="title">API Keys & Rotas</span>
                <span className="desc">Tabela de chaves (100 reqs)</span>
              </div>
            </SidebarNavItem>

            <SidebarNavItem
              type="button"
              $active={activeTab === 'gisa'}
              onClick={() => setActiveTab('gisa')}
            >
              <div className="nav-icon">
                <GidIaIcon size={22} />
              </div>
              <div className="nav-text">
                <span className="title">Chat & Chaves GID IA</span>
                <span className="desc">
                  {gisaUnlocked ? 'GID IA Criptografada Ativa' : 'Chaves IA & Assistente'}
                </span>
              </div>
            </SidebarNavItem>

            <SidebarNavItem
              type="button"
              $active={activeTab === 'email'}
              onClick={() => setActiveTab('email')}
            >
              <div className="nav-icon">
                <FiMail />
              </div>
              <div className="nav-text">
                <span className="title">Relatório Diário (E-mail)</span>
                <span className="desc">PDF, CSV, EXCEL & CC</span>
              </div>
            </SidebarNavItem>

            {isAdmin && (
              <SidebarNavItem
                type="button"
                $active={activeTab === 'smtp'}
                onClick={() => setActiveTab('smtp')}
              >
                <div className="nav-icon">
                  <FiServer />
                </div>
                <div className="nav-text">
                  <span className="title">Servidor SMTP</span>
                  <span className="desc">Banco Criptografado AES-256</span>
                </div>
              </SidebarNavItem>
            )}

            <SidebarNavItem
              type="button"
              $active={activeTab === 'docs'}
              onClick={() => setActiveTab('docs')}
            >
              <div className="nav-icon">
                <FiBookOpen />
              </div>
              <div className="nav-text">
                <span className="title">DOCS & Como Usar</span>
                <span className="desc">Rotas, E-mails e GID IA</span>
              </div>
            </SidebarNavItem>
          </SidebarNavList>

          <SidebarUserFooter ref={userFooterRef}>
            <small style={{ fontSize: 10.5, opacity: 0.72, lineHeight: 1.35 }}>
              API Keys com teto de <strong>{maxRequestsPerKey} reqs</strong> e cofre{' '}
              <strong>AES-256-GCM</strong>.
            </small>

            <HubUserCard
              title={`${nickname} - Opções da Conta`}
              onClick={() => setUserMenuOpen((prev) => !prev)}
            >
              <div className="avatar">{nickname.slice(0, 2).toUpperCase()}</div>
              <div className="user-info">
                <span className="nickname" title={nickname}>
                  {nickname}
                </span>
                <span className="role">{userRole}</span>
              </div>
              <div className="chevron-indicator">
                <FaChevronUp
                  size={12}
                  style={{
                    transform: userMenuOpen ? 'rotate(180deg)' : 'none',
                    transition: 'transform 0.2s ease',
                  }}
                />
              </div>
            </HubUserCard>

            {userMenuOpen && (
              <HubUserDropdown>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setUserMenuOpen(false)
                    handleBackToPanel()
                  }}
                  title="Voltar ao Painel Principal"
                >
                  <FaGlobeAmericas size={17} style={{ color: '#38bdf8' }} />
                  <span>Painel Principal</span>
                </button>

                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    toggleTheme()
                    setUserMenuOpen(false)
                  }}
                  title="Alternar Tema"
                >
                  {theme === 'dark' ? (
                    <MdLightMode size={18} style={{ color: '#facc15' }} />
                  ) : (
                    <MdDarkMode size={18} style={{ color: '#60a5fa' }} />
                  )}
                  <span>Tema {theme === 'dark' ? 'Claro' : 'Escuro'}</span>
                </button>

                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setUserMenuOpen(false)
                    if (onOpenUserSettings) {
                      onOpenUserSettings()
                    } else {
                      setLocalSettingsOpen(true)
                    }
                  }}
                  title="Configurações do Usuário"
                >
                  <MdSettings size={18} style={{ color: '#38bdf8' }} />
                  <span>Configurações</span>
                </button>

                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => {
                    setUserMenuOpen(false)
                    if (onOpenWelcome) {
                      onOpenWelcome()
                    } else {
                      setLocalWelcomeOpen(true)
                    }
                  }}
                  title="Guia de Boas-Vindas"
                >
                  <BsStars size={18} style={{ color: '#a6c10b' }} />
                  <span>Bem vindo</span>
                </button>

                <Link
                  to="/termos-de-uso"
                  className="dropdown-item"
                  onClick={() => setUserMenuOpen(false)}
                  title="Termos de Uso"
                >
                  <FaFileContract size={17} style={{ color: '#94a3b8' }} />
                  <span>Termos de uso</span>
                </Link>

                <Link
                  to="/sobre"
                  className="dropdown-item"
                  onClick={() => setUserMenuOpen(false)}
                  title="Sobre o GID"
                >
                  <BsInfoCircleFill size={17} style={{ color: '#94a3b8' }} />
                  <span>Sobre</span>
                </Link>

                <div className="dropdown-divider" />

                <button
                  type="button"
                  className="dropdown-item logout-action"
                  onClick={() => {
                    setUserMenuOpen(false)
                    signOut()
                  }}
                  title="Sair da Conta"
                >
                  <TbDoorExit size={18} style={{ color: '#ef4444' }} />
                  <span>Sair</span>
                </button>
              </HubUserDropdown>
            )}
          </SidebarUserFooter>
        </HubSidebar>

        {/* =====================================================================
            ÁREA PRINCIPAL DE CONTEÚDO
           ===================================================================== */}
        <HubMainArea>
          {showDocBanner && (
            <DocNoticeBanner>
              <div className="banner-left">
                <div className="icon-box">
                  <FiBookOpen />
                </div>
                <div className="text-box">
                  <strong>
                    📘 Documentação Detalhada Disponível ({userRole.toUpperCase()})
                  </strong>
                  <span>
                    Acesse a opção <strong>DOCS & Como Usar</strong> no menu lateral para consultar
                    exemplos detalhados de cada rota permitida ao seu perfil, parâmetros de e-mail
                    (PDF/CSV/EXCEL) e configuração da GID IA.
                  </span>
                </div>
              </div>
              <div className="banner-actions">
                <ActionBtn
                  type="button"
                  $variant="primary"
                  $small
                  onClick={() => setActiveTab('docs')}
                >
                  <FiBookOpen /> Ver DOCS Detalhado
                </ActionBtn>
                <ActionBtn type="button" $variant="secondary" $small onClick={fecharDocBanner}>
                  <FiX /> Ocultar
                </ActionBtn>
              </div>
            </DocNoticeBanner>
          )}

          {/* ===================================================================
              SEÇÃO 1: API KEYS (TABELA + BOTÃO CRIAR + MODAL + SUB-MODAL)
             =================================================================== */}
          {activeTab === 'keys' && (
            <>
              <SectionHeaderBar>
                <div className="title-block">
                  <h2>
                    <FiKey /> Gerenciamento de API Keys do Sistema
                  </h2>
                  <p>{rolePolicyDesc}</p>
                </div>
                <div className="actions-block">
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    onClick={carregarTudo}
                    disabled={loadingKeys}
                  >
                    <FiRefreshCw /> Atualizar Tabela
                  </ActionBtn>
                  <ActionBtn type="button" $variant="primary" onClick={abrirModalNovaApiKey}>
                    <FiPlus /> Criar Nova API Key
                  </ActionBtn>
                </div>
              </SectionHeaderBar>

              {newlyCreatedKey && (
                <SecretKeyCreatedBox>
                  <strong>
                    🎉 Nova API Key gerada com sucesso (Limite: {maxRequestsPerKey} requisições)!
                    Copie e guarde agora — por segurança ela não será exibida novamente:
                  </strong>
                  <div className="key-display">
                    <span>{newlyCreatedKey}</span>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <ActionBtn
                        type="button"
                        $variant="success"
                        $small
                        onClick={() => copiarTexto(newlyCreatedKey, 'API Key')}
                      >
                        <FiCopy /> Copiar Chave
                      </ActionBtn>
                      <ActionBtn
                        type="button"
                        $variant="secondary"
                        $small
                        onClick={() => setNewlyCreatedKey(null)}
                      >
                        <FiX /> Fechar
                      </ActionBtn>
                    </div>
                  </div>
                </SecretKeyCreatedBox>
              )}

              <SurfaceCard>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 10,
                  }}
                >
                  <div>
                    <strong style={{ fontSize: 14 }}>
                      Tabela de API Keys Cadastradas ({apiKeys.length})
                    </strong>
                    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
                      Toda API Key possui teto estrito de{' '}
                      <strong>{maxRequestsPerKey} requisições</strong> (aplicável a Administrador,
                      Suporte e Conferente).
                    </div>
                  </div>
                </div>

                <DataTableWrapper>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>Nome / Integração</th>
                        <th>Prefixo da Chave</th>
                        <th>Perfil Vinculado</th>
                        <th>Rotas Permitidas</th>
                        <th>Limite de Requisições</th>
                        <th>Status</th>
                        <th>Último Uso</th>
                        <th style={{ textAlign: 'right' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {apiKeys.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', padding: '28px 16px' }}>
                            Nenhuma API Key cadastrada ainda. Clique em{' '}
                            <strong>"Criar Nova API Key"</strong> acima para gerar a primeira.
                          </td>
                        </tr>
                      ) : (
                        apiKeys.map((k) => {
                          const maxReqs = k.maxRequests || maxRequestsPerKey || 100
                          const used = Number(k.usageCount) || 0
                          const pct = Math.round((used / maxReqs) * 100)
                          const limitReached = used >= maxReqs

                          return (
                            <tr key={k.id}>
                              <td>
                                <strong style={{ display: 'block', fontSize: 13 }}>{k.name}</strong>
                                <span style={{ fontSize: 11, opacity: 0.75 }}>
                                  Criado por: {k.ownerName}
                                </span>
                              </td>
                              <td>
                                <code style={{ fontWeight: 700, fontSize: 12 }}>
                                  {k.keyPrefix}••••••••
                                </code>
                              </td>
                              <td>
                                <RoleBadge $role={String(k.ownerRole || k.roleAtCreation).toLowerCase()}>
                                  {String(k.ownerRole || k.roleAtCreation).toUpperCase()}
                                </RoleBadge>
                              </td>
                              <td>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 6,
                                    flexWrap: 'wrap',
                                    maxWidth: 280,
                                  }}
                                >
                                  {k.allowedRoutes.slice(0, 3).map((rt) => {
                                    const [m, p] = rt.split(' ')
                                    return (
                                      <span
                                        key={rt}
                                        style={{
                                          display: 'inline-flex',
                                          alignItems: 'center',
                                          gap: 4,
                                          fontSize: 11,
                                        }}
                                      >
                                        <MethodBadge $method={m || 'GET'}>{m}</MethodBadge>
                                        <code style={{ fontSize: 11 }}>{p}</code>
                                      </span>
                                    )
                                  })}
                                  {k.allowedRoutes.length > 3 && (
                                    <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.8 }}>
                                      +{k.allowedRoutes.length - 3} rota(s)
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td>
                                <UsageProgressWrapper $pct={pct}>
                                  <div className="usage-label">
                                    <span>
                                      {used} / {maxReqs} reqs
                                    </span>
                                    <span>{pct}%</span>
                                  </div>
                                  <div className="bar-bg">
                                    <div className="bar-fill" />
                                  </div>
                                </UsageProgressWrapper>
                              </td>
                              <td>
                                <StatusTag
                                  $active={k.isActive && !limitReached}
                                  $warn={limitReached}
                                >
                                  {limitReached
                                    ? 'Limite 100 Reqs Atingido'
                                    : k.isActive
                                      ? 'Ativa'
                                      : 'Pausada'}
                                </StatusTag>
                              </td>
                              <td>
                                {k.lastUsedAt
                                  ? new Date(k.lastUsedAt).toLocaleString('pt-BR')
                                  : 'Nunca utilizada'}
                              </td>
                              <td style={{ textAlign: 'right' }}>
                                <div
                                  style={{
                                    display: 'inline-flex',
                                    gap: 6,
                                    justifyContent: 'flex-end',
                                  }}
                                >
                                  <ActionBtn
                                    type="button"
                                    $variant="secondary"
                                    $small
                                    onClick={() => abrirModalEditarApiKey(k)}
                                    title="Editar Nome e Rotas Vinculadas"
                                  >
                                    <FiEdit2 /> Rotas / Editar
                                  </ActionBtn>
                                  <ActionBtn
                                    type="button"
                                    $variant="secondary"
                                    $small
                                    onClick={() => handleToggleKeyStatus(k)}
                                    title={k.isActive ? 'Pausar Chave' : 'Ativar Chave'}
                                  >
                                    <FiPower /> {k.isActive ? 'Pausar' : 'Ativar'}
                                  </ActionBtn>
                                  <ActionBtn
                                    type="button"
                                    $variant="danger"
                                    $small
                                    onClick={() => handleDeleteApiKey(k)}
                                    title="Revogar e Excluir"
                                  >
                                    <FiTrash2 />
                                  </ActionBtn>
                                </div>
                              </td>
                            </tr>
                          )
                        })
                      )}
                    </tbody>
                  </StyledTable>
                </DataTableWrapper>
              </SurfaceCard>
            </>
          )}

          {/* ===================================================================
              SEÇÃO 2: CHAT GID IA & TABELA DE CHAVES IA CRIPTOGRAFADAS
             =================================================================== */}
          {activeTab === 'gisa' && (
            <>
              <SectionHeaderBar>
                <div className="title-block">
                  <h2>
                    <GidIaIcon size={26} /> Assistente GID IA & Chaves Criptografadas
                  </h2>
                  <p>
                    Gerencie suas chaves de IA salvas com criptografia militar{' '}
                    <strong>AES-256-GCM</strong> e converse em tempo real com a inteligência{' '}
                    <strong>GID IA</strong>.
                  </p>
                </div>
                <div className="actions-block">
                  <ActionBtn type="button" $variant="primary" onClick={abrirModalNovaChaveIa}>
                    <FiPlus /> Adicionar Chave de IA
                  </ActionBtn>
                </div>
              </SectionHeaderBar>

              {/* Tabela de Chaves de IA Cadastradas (Criptografadas) */}
              <SurfaceCard>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 10,
                  }}
                >
                  <div>
                    <strong style={{ fontSize: 14 }}>
                      Chaves de IA Cadastradas ({aiKeys.length})
                    </strong>
                    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
                      Suas chaves jamais ficam expostas em texto puro — o armazenamento no banco
                      utiliza cifra autenticada <strong>AES-256-GCM</strong>.
                    </div>
                  </div>
                </div>

                <DataTableWrapper>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>Identificação</th>
                        <th>Provedor de IA</th>
                        <th>Modelo Configurado</th>
                        <th>Chave Mascarada</th>
                        <th>Hash Criptografado (Banco)</th>
                        <th>Status na GID IA</th>
                        <th>Atualizado em</th>
                        <th style={{ textAlign: 'right' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {aiKeys.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', padding: '26px 16px' }}>
                            Nenhuma chave de IA cadastrada. Clique em{' '}
                            <strong>"Adicionar Chave de IA"</strong> para vincular seu provedor e
                            liberar o Chat da GID IA.
                          </td>
                        </tr>
                      ) : (
                        aiKeys.map((item) => (
                          <tr key={item.id}>
                            <td>
                              <strong style={{ fontSize: 13 }}>{item.name}</strong>
                            </td>
                            <td>
                              <span style={{ fontWeight: 700, textTransform: 'uppercase' }}>
                                {item.provider}
                              </span>
                            </td>
                            <td>
                              <code>{item.model}</code>
                            </td>
                            <td>
                              <code>{item.maskedKey}</code>
                            </td>
                            <td>
                              <CipherBadge title="Criptografado em banco com AES-256-GCM">
                                <FiLock /> {item.encryptionAlgorithm}: {item.encryptedPreview}
                              </CipherBadge>
                            </td>
                            <td>
                              <StatusTag $active={item.isActive}>
                                {item.isActive ? '✔ Em Uso na GID IA' : 'Inativa'}
                              </StatusTag>
                            </td>
                            <td>
                              {item.updatedAt
                                ? new Date(item.updatedAt).toLocaleString('pt-BR')
                                : '-'}
                            </td>
                            <td style={{ textAlign: 'right' }}>
                              <div
                                style={{
                                  display: 'inline-flex',
                                  gap: 6,
                                  justifyContent: 'flex-end',
                                }}
                              >
                                {!item.isActive && (
                                  <ActionBtn
                                    type="button"
                                    $variant="success"
                                    $small
                                    onClick={() => handleAtivarChaveIaNaTabela(item)}
                                  >
                                    <FiCheckCircle /> Usar na GID IA
                                  </ActionBtn>
                                )}
                                <ActionBtn
                                  type="button"
                                  $variant="secondary"
                                  $small
                                  onClick={() => abrirModalEditarChaveIa(item)}
                                >
                                  <FiEdit2 /> Editar
                                </ActionBtn>
                                <ActionBtn
                                  type="button"
                                  $variant="danger"
                                  $small
                                  onClick={() => handleExcluirChaveIa(item)}
                                >
                                  <FiTrash2 />
                                </ActionBtn>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </StyledTable>
                </DataTableWrapper>
              </SurfaceCard>

              {/* KPIs em Tempo Real + Chat da GISA */}
              {gisaSummary && (
                <KpiMiniGrid>
                  <div className="kpi-box">
                    <span>Distribuidores Ativos</span>
                    <strong>
                      {gisaSummary.kpis.totalDistribuidoresAtivos} (
                      {gisaSummary.kpis.distribuidoresComEnvioRecente} em dia)
                    </strong>
                  </div>
                  <div className="kpi-box">
                    <span>Sellout (Últimos 30d)</span>
                    <strong>
                      {Number(gisaSummary.kpis.selloutUltimos30DiasValor || 0).toLocaleString(
                        'pt-BR',
                        { style: 'currency', currency: 'BRL' },
                      )}
                    </strong>
                  </div>
                  <div className="kpi-box">
                    <span>Clientes Ativos (PDVs)</span>
                    <strong>
                      {gisaSummary.kpis.totalClientesAtivos.toLocaleString('pt-BR')}
                    </strong>
                  </div>
                  <div className="kpi-box">
                    <span>Produtos Homologados</span>
                    <strong>
                      {gisaSummary.kpis.totalProdutosHomologados.toLocaleString('pt-BR')}
                    </strong>
                  </div>
                </KpiMiniGrid>
              )}

              <SurfaceCard>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: 16,
                    paddingBottom: 14,
                    borderBottom: '1px solid rgba(148, 163, 184, 0.2)',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                    <div
                      style={{
                        position: 'relative',
                        width: 56,
                        height: 56,
                        borderRadius: '50%',
                        padding: 2,
                        background: 'linear-gradient(135deg, #a6c10b, #38bdf8)',
                        flexShrink: 0,
                      }}
                    >
                      <img
                        src={gisaAvatar}
                        alt="Assistente GID IA"
                        style={{
                          width: '100%',
                          height: '100%',
                          borderRadius: '50%',
                          objectFit: 'cover',
                        }}
                      />
                      <span
                        style={{
                          position: 'absolute',
                          bottom: 2,
                          right: 2,
                          width: 13,
                          height: 13,
                          borderRadius: '50%',
                          background: gisaUnlocked ? '#10b981' : '#f59e0b',
                          border: '2px solid #ffffff',
                        }}
                      />
                    </div>
                    <div>
                      <h4 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>
                        Assistente Flutuante GID IA (Copilot GID)
                      </h4>
                      <span style={{ fontSize: 12.5, opacity: 0.8 }}>
                        {gisaUnlocked
                          ? `Ativa em todas as telas do sistema • Modelo em uso: ${activeAiProvider.toUpperCase()} (${activeAiModel})`
                          : 'A bolha flutuante da GID IA está visível no canto direito da tela. Vincule uma Chave de IA acima para liberar o motor conversacional completo.'}
                      </span>
                    </div>
                  </div>

                  <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                    {gisaUnlocked && (
                      <ActionBtn
                        type="button"
                        $variant="secondary"
                        onClick={() => carregarResumoGisa()}
                      >
                        <FiRefreshCw /> Atualizar KPIs
                      </ActionBtn>
                    )}
                    <ActionBtn
                      type="button"
                      $variant="primary"
                      onClick={() => window.dispatchEvent(new CustomEvent('gid:open-gisa'))}
                    >
                      <GidIaIcon size={18} /> Abrir Chat Flutuante da GID IA
                    </ActionBtn>
                  </div>
                </div>

                <div
                  style={{
                    marginTop: 14,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
                    gap: 10,
                  }}
                >
                  <button
                    type="button"
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent('gid:open-gisa', {
                          detail: {
                            initialQuery:
                              'Mostre o ranking de Sellout e faturamento por distribuidor com gráfico interativo.',
                          },
                        }),
                      )
                    }
                    style={{
                      textAlign: 'left',
                      padding: '12px 14px',
                      borderRadius: 10,
                      border: '1px solid rgba(2, 132, 199, 0.35)',
                      background: 'rgba(2, 132, 199, 0.08)',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                  >
                    <strong style={{ display: 'block', fontSize: 13, color: '#0284c7' }}>
                      📊 Analisar Sellout & Gráficos
                    </strong>
                    <span style={{ fontSize: 11.5, opacity: 0.8 }}>
                      Abre o painel lateral da GID IA com gráfico interativo de barras/linhas/área.
                    </span>
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent('gid:open-gisa', {
                          detail: {
                            initialQuery:
                              'Faça uma auditoria de regularidade de envios dos distribuidores ativos.',
                          },
                        }),
                      )
                    }
                    style={{
                      textAlign: 'left',
                      padding: '12px 14px',
                      borderRadius: 10,
                      border: '1px solid rgba(139, 92, 246, 0.35)',
                      background: 'rgba(139, 92, 246, 0.08)',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                  >
                    <strong style={{ display: 'block', fontSize: 13, color: '#8b5cf6' }}>
                      🔍 Auditar Regularidade de Envios
                    </strong>
                    <span style={{ fontSize: 11.5, opacity: 0.8 }}>
                      Verifica distribuidores em dia vs pendentes há mais de 7 dias.
                    </span>
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent('gid:open-gisa', {
                          detail: {
                            initialQuery: '/pdf',
                          },
                        }),
                      )
                    }
                    style={{
                      textAlign: 'left',
                      padding: '12px 14px',
                      borderRadius: 10,
                      border: '1px solid rgba(239, 68, 68, 0.35)',
                      background: 'rgba(239, 68, 68, 0.08)',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                  >
                    <strong style={{ display: 'block', fontSize: 13, color: '#ef4444' }}>
                      📄 Gerar PDF Executivo na Hora
                    </strong>
                    <span style={{ fontSize: 11.5, opacity: 0.8 }}>
                      Compila e baixa o relatório executivo em PDF direto pela GID IA.
                    </span>
                  </button>

                  <button
                    type="button"
                    onClick={() =>
                      window.dispatchEvent(
                        new CustomEvent('gid:open-gisa', {
                          detail: {
                            initialQuery: '/excel',
                          },
                        }),
                      )
                    }
                    style={{
                      textAlign: 'left',
                      padding: '12px 14px',
                      borderRadius: 10,
                      border: '1px solid rgba(22, 163, 74, 0.35)',
                      background: 'rgba(22, 163, 74, 0.08)',
                      cursor: 'pointer',
                      color: 'inherit',
                    }}
                  >
                    <strong style={{ display: 'block', fontSize: 13, color: '#16a34a' }}>
                      📊 Exportar Planilha Excel (.xlsx)
                    </strong>
                    <span style={{ fontSize: 11.5, opacity: 0.8 }}>
                      Gera planilha multi-abas com KPIs, Sellout, Envios e Produtos.
                    </span>
                  </button>
                </div>
              </SurfaceCard>

              {/* ===============================================================
                  BLOCO INDIVIDUAL DO USUÁRIO: MEUS ATALHOS & PADRÕES PESSOAIS
                 =============================================================== */}
              <SurfaceCard>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 12,
                  }}
                >
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <strong style={{ fontSize: 15 }}>
                        ⚡ Meus Atalhos Rápidos & Padrões Pessoais da GID IA ({userShortcuts.length})
                      </strong>
                      <CipherBadge>
                        <FiLock /> Isolado por Usuário ({user?.name || user?.nickname || 'Sua Conta'})
                      </CipherBadge>
                    </div>
                    <div style={{ fontSize: 12, opacity: 0.78, marginTop: 4 }}>
                      Defina seus próprios atalhos <code>/comando</code>, botões fixados no topo da
                      GID IA e padrões de período.{' '}
                      <strong>
                        Estes atalhos e sua API Key acima são exclusivos da sua conta (separados dos
                        demais usuários).
                      </strong>
                    </div>
                  </div>
                  <ActionBtn
                    type="button"
                    $variant="primary"
                    onClick={abrirModalNovoAtalhoPessoal}
                  >
                    <FiPlus /> Novo Atalho Pessoal
                  </ActionBtn>
                </div>

                <DataTableWrapper>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>Comando</th>
                        <th>Botão / Rótulo</th>
                        <th>Função Padrão</th>
                        <th>Período Padrão</th>
                        <th>Pergunta / Comando Automático</th>
                        <th>Barra do Chat</th>
                        <th style={{ textAlign: 'right' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {userShortcuts.length === 0 ? (
                        <tr>
                          <td colSpan={7} style={{ textAlign: 'center', padding: '24px 16px' }}>
                            Você ainda não criou atalhos pessoais. Clique em{' '}
                            <strong>"Novo Atalho Pessoal"</strong> para criar seus próprios botões e
                            comandos <code>/</code> no Chat da GISA.
                          </td>
                        </tr>
                      ) : (
                        userShortcuts.map((sc) => (
                          <tr key={sc.id}>
                            <td>
                              <code>{sc.command}</code>
                            </td>
                            <td>
                              <strong>{sc.label}</strong>
                            </td>
                            <td>
                              <MethodBadge $method="GET">
                                {sc.defaultAction.toUpperCase()}
                              </MethodBadge>
                            </td>
                            <td>{formatPeriodLabel(sc.defaultPeriod)}</td>
                            <td style={{ maxWidth: 320 }}>
                              <div
                                style={{
                                  fontSize: 12,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                }}
                                title={sc.promptTemplate}
                              >
                                {sc.promptTemplate}
                              </div>
                            </td>
                            <td>
                              <StatusTag $active={sc.pinToBar}>
                                {sc.pinToBar ? '📌 Fixado no Topo' : 'Menu /'}
                              </StatusTag>
                            </td>
                            <td style={{ textAlign: 'right' }}>
                              <div
                                style={{
                                  display: 'inline-flex',
                                  gap: 6,
                                  justifyContent: 'flex-end',
                                }}
                              >
                                <ActionBtn
                                  type="button"
                                  $variant="success"
                                  $small
                                  onClick={() =>
                                    window.dispatchEvent(
                                      new CustomEvent('gid:open-gisa', {
                                        detail: { initialQuery: sc.promptTemplate },
                                      }),
                                    )
                                  }
                                  title="Executar este atalho agora no Chat da GISA"
                                >
                                  <BsStars /> Executar
                                </ActionBtn>
                                <ActionBtn
                                  type="button"
                                  $variant="secondary"
                                  $small
                                  onClick={() => abrirModalEditarAtalhoPessoal(sc)}
                                >
                                  <FiEdit2 /> Editar
                                </ActionBtn>
                                <ActionBtn
                                  type="button"
                                  $variant="danger"
                                  $small
                                  onClick={() => handleExcluirAtalhoPessoal(sc)}
                                >
                                  <FiTrash2 />
                                </ActionBtn>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </StyledTable>
                </DataTableWrapper>
              </SurfaceCard>

              {/* ===============================================================
                  BLOCO COMPARTILHADO ENTRE USUÁRIOS: TREINAMENTO & HISTÓRICO GISA
                 =============================================================== */}
              <SurfaceCard>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 12,
                  }}
                >
                  <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                      <strong style={{ fontSize: 15 }}>
                        🧠 Base de Treinamento & Aprendizado Contínuo da GID IA ({gisaTrainings.length})
                      </strong>
                      <StatusTag $active={true}>
                        🌐 Treinamento Compartilhado entre Usuários
                      </StatusTag>
                    </div>
                    <div style={{ fontSize: 12, opacity: 0.78, marginTop: 4 }}>
                      Toda pergunta que você digita no histórico e a GID IA ainda não sabe como fazer
                      é salva aqui automaticamente como <strong>Pendente de Treino</strong>. Ao
                      treinar uma função aqui,{' '}
                      <strong>
                        todos os usuários do GID passam a contar com esse aprendizado da GID IA
                      </strong>{' '}
                      (sem compartilhar sua API Key ou seus atalhos pessoais).
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    <ActionBtn
                      type="button"
                      $variant="secondary"
                      onClick={carregarTreinamentosGisa}
                    >
                      <FiRefreshCw /> Atualizar Fila
                    </ActionBtn>
                    <ActionBtn
                      type="button"
                      $variant="primary"
                      onClick={abrirModalNovoTreinamento}
                    >
                      <FiPlus /> Ensinar Nova Função à GID IA
                    </ActionBtn>
                  </div>
                </div>

                <MethodTabsBar style={{ marginTop: 8 }}>
                  <MethodTabBtn
                    type="button"
                    $active={trainingFilterTab === 'ALL'}
                    onClick={() => setTrainingFilterTab('ALL')}
                  >
                    Todos ({gisaTrainings.length})
                  </MethodTabBtn>
                  <MethodTabBtn
                    type="button"
                    $active={trainingFilterTab === 'PENDENTE_TREINO'}
                    onClick={() => setTrainingFilterTab('PENDENTE_TREINO')}
                  >
                    ⏳ Capturados do Histórico — Pendentes de Treino (
                    {gisaTrainings.filter((t) => t.status === 'PENDENTE_TREINO').length})
                  </MethodTabBtn>
                  <MethodTabBtn
                    type="button"
                    $active={trainingFilterTab === 'TREINADO'}
                    onClick={() => setTrainingFilterTab('TREINADO')}
                  >
                    ✅ Treinados & Ativos (
                    {gisaTrainings.filter((t) => t.status === 'TREINADO').length})
                  </MethodTabBtn>
                </MethodTabsBar>

                <DataTableWrapper>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>O que foi digitado no Histórico (Gatilho)</th>
                        <th>Status de Aprendizado</th>
                        <th>Função & Entidade Vinculada</th>
                        <th>Como a GID IA deve fazer (Regra / Instrução)</th>
                        <th>Autor & Uso</th>
                        <th style={{ textAlign: 'right' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredGisaTrainings.length === 0 ? (
                        <tr>
                          <td colSpan={6} style={{ textAlign: 'center', padding: '26px 16px' }}>
                            Nenhum registro nesta aba. Sempre que você pedir algo no chat que a GID IA
                            não souber fazer ou encontrar, ela salvará automaticamente aqui para
                            treinamento — ou clique em{' '}
                            <strong>"Ensinar Nova Função à GID IA"</strong> acima!
                          </td>
                        </tr>
                      ) : (
                        filteredGisaTrainings.map((tr) => (
                          <tr key={tr.id}>
                            <td style={{ maxWidth: 280 }}>
                              <strong style={{ fontSize: 12.5 }}>"{tr.triggerPhrase}"</strong>
                              {tr.keywords && (
                                <div style={{ fontSize: 11, opacity: 0.72, marginTop: 2 }}>
                                  Palavras-chave: <code>{tr.keywords}</code>
                                </div>
                              )}
                            </td>
                            <td>
                              {tr.status === 'TREINADO' ? (
                                <StatusTag $active={true}>✅ Treinado & Ativo</StatusTag>
                              ) : (
                                <StatusTag $active={false}>
                                  ⏳ Pendente de Treino (Histórico)
                                </StatusTag>
                              )}
                            </td>
                            <td>
                              <MethodBadge $method="POST">
                                {tr.targetAction.toUpperCase()}
                              </MethodBadge>
                              {tr.entityMapping && (
                                <div style={{ fontSize: 11.5, fontWeight: 700, marginTop: 4 }}>
                                  ➔ {tr.entityMapping}
                                </div>
                              )}
                            </td>
                            <td style={{ maxWidth: 320 }}>
                              {tr.expectedBehavior ? (
                                <div style={{ fontSize: 12, lineHeight: 1.45 }}>
                                  {tr.expectedBehavior}
                                </div>
                              ) : (
                                <span style={{ fontSize: 11.5, opacity: 0.65, fontStyle: 'italic' }}>
                                  Aguardando definição de como executar esta função...
                                </span>
                              )}
                            </td>
                            <td>
                              <div style={{ fontWeight: 700, fontSize: 12 }}>
                                {tr.createdByName}
                              </div>
                              <small style={{ opacity: 0.75 }}>
                                {tr.hitCount}x no histórico •{' '}
                                {tr.updatedAt
                                  ? new Date(tr.updatedAt).toLocaleDateString('pt-BR')
                                  : ''}
                              </small>
                            </td>
                            <td style={{ textAlign: 'right' }}>
                              <div
                                style={{
                                  display: 'inline-flex',
                                  gap: 6,
                                  justifyContent: 'flex-end',
                                }}
                              >
                                <ActionBtn
                                  type="button"
                                  $variant={tr.status === 'PENDENTE_TREINO' ? 'primary' : 'secondary'}
                                  $small
                                  onClick={() => abrirModalEnsinarTreinamento(tr)}
                                >
                                  <FiEdit2 />{' '}
                                  {tr.status === 'PENDENTE_TREINO'
                                    ? '🎓 Ensinar à GID IA'
                                    : 'Editar Treino'}
                                </ActionBtn>
                                <ActionBtn
                                  type="button"
                                  $variant="danger"
                                  $small
                                  onClick={() => handleExcluirTreinamento(tr)}
                                >
                                  <FiTrash2 />
                                </ActionBtn>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </StyledTable>
                </DataTableWrapper>
              </SurfaceCard>
            </>
          )}

          {/* ===================================================================
              SEÇÃO 3: RELATÓRIO DIÁRIO / PROGRAMADO POR E-MAIL (TABELA + MODAIS)
             =================================================================== */}
          {activeTab === 'email' && (
            <>
              <SectionHeaderBar>
                <div className="title-block">
                  <h2>
                    <FiMail /> Relatórios Programados por E-mail (PDF, CSV e EXCEL)
                  </h2>
                  <p>
                    Gerencie múltiplos agendamentos de envio por e-mail com cópia (CC), escolha de
                    telas, relatórios, distribuidores, período e frequência de disparo.
                  </p>
                </div>
                <div className="actions-block">
                  <ActionBtn
                    type="button"
                    $variant="primary"
                    onClick={abrirModalNovoAgendamento}
                  >
                    <FiPlus /> Novo Relatório por E-mail
                  </ActionBtn>
                </div>
              </SectionHeaderBar>

              <SurfaceCard>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 10,
                  }}
                >
                  <div>
                    <strong style={{ fontSize: 14 }}>
                      Tabela de Relatórios por E-mail Configurados ({schedules.length})
                    </strong>
                    <div style={{ fontSize: 12, opacity: 0.75, marginTop: 2 }}>
                      Clique em <strong>"Novo Relatório por E-mail"</strong> ou em{' '}
                      <strong>"Editar"</strong> para abrir o modal de configuração de telas,
                      formatos (PDF/CSV/EXCEL), distribuidores e período.
                    </div>
                  </div>
                </div>

                <DataTableWrapper>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>Nome do Relatório</th>
                        <th>E-mail Principal & CC</th>
                        <th>Telas & Relatórios</th>
                        <th>Formatos</th>
                        <th>Distribuidores & Período</th>
                        <th>Frequência & Horário</th>
                        <th>Status / Último Envio</th>
                        <th style={{ textAlign: 'right' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {schedules.length === 0 ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', padding: '28px 16px' }}>
                            Nenhum agendamento de e-mail configurado. Clique em{' '}
                            <strong>"Novo Relatório por E-mail"</strong> acima para criar o
                            primeiro.
                          </td>
                        </tr>
                      ) : (
                        schedules.map((sched) => (
                          <tr key={sched.id}>
                            <td>
                              <strong style={{ fontSize: 13 }}>{sched.name}</strong>
                            </td>
                            <td>
                              <div style={{ fontWeight: 700 }}>{sched.recipientEmail}</div>
                              {sched.ccEmails.length > 0 && (
                                <small style={{ opacity: 0.8 }}>
                                  CC: {sched.ccEmails.join(', ')}
                                </small>
                              )}
                            </td>
                            <td>
                              <span style={{ fontWeight: 700 }}>
                                {sched.reportTypes.length} selecionado(s)
                              </span>
                              <div style={{ fontSize: 11, opacity: 0.75 }}>
                                {sched.reportTypes
                                  .slice(0, 2)
                                  .map(
                                    (id) =>
                                      reportsCatalog.find((r) => r.id === id)?.title || id,
                                  )
                                  .join(', ')}
                                {sched.reportTypes.length > 2
                                  ? ` +${sched.reportTypes.length - 2}`
                                  : ''}
                              </div>
                            </td>
                            <td>
                              <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                                {(sched.exportFormats || ['PDF']).map((fmt) => (
                                  <MethodBadge
                                    key={fmt}
                                    $method={
                                      fmt === 'PDF' ? 'DELETE' : fmt === 'EXCEL' ? 'GET' : 'POST'
                                    }
                                  >
                                    {fmt}
                                  </MethodBadge>
                                ))}
                              </div>
                            </td>
                            <td>
                              <div style={{ fontWeight: 700 }}>
                                {sched.distributorIds === 'ALL'
                                  ? 'Todos os Distribuidores'
                                  : `${sched.distributorIds.length} Distribuidor(es)`}
                              </div>
                              <small style={{ opacity: 0.8 }}>
                                Período: {formatPeriodLabel(sched.periodWindow)}
                              </small>
                            </td>
                            <td>
                              <div style={{ fontWeight: 700 }}>
                                {formatFrequencyLabel(sched.frequency)}
                              </div>
                              <small style={{ opacity: 0.8 }}>Horário: {sched.sendTime}</small>
                            </td>
                            <td>
                              <StatusTag $active={sched.isActive}>
                                {sched.isActive ? 'Ativo' : 'Pausado'}
                              </StatusTag>
                              {sched.lastSentAt && (
                                <div style={{ fontSize: 10, opacity: 0.75, marginTop: 4 }}>
                                  Último: {new Date(sched.lastSentAt).toLocaleString('pt-BR')}
                                </div>
                              )}
                            </td>
                            <td style={{ textAlign: 'right' }}>
                              <div
                                style={{
                                  display: 'inline-flex',
                                  gap: 6,
                                  justifyContent: 'flex-end',
                                }}
                              >
                                <ActionBtn
                                  type="button"
                                  $variant="success"
                                  $small
                                  onClick={() => handleDispararTesteDaTabela(sched)}
                                  disabled={testingScheduleId === sched.id}
                                  title="Enviar este relatório agora por e-mail"
                                >
                                  <FiSend />{' '}
                                  {testingScheduleId === sched.id ? 'Enviando...' : 'Testar'}
                                </ActionBtn>
                                <ActionBtn
                                  type="button"
                                  $variant="secondary"
                                  $small
                                  onClick={() => abrirModalEditarAgendamento(sched)}
                                >
                                  <FiEdit2 /> Editar
                                </ActionBtn>
                                <ActionBtn
                                  type="button"
                                  $variant="danger"
                                  $small
                                  onClick={() => handleExcluirAgendamentoEmail(sched)}
                                >
                                  <FiTrash2 />
                                </ActionBtn>
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </StyledTable>
                </DataTableWrapper>
              </SurfaceCard>
            </>
          )}

          {/* ===================================================================
              SEÇÃO 4: SERVIDOR SMTP CRIPTOGRAFADO EM BANCO (EXCLUSIVO ADMIN)
             =================================================================== */}
          {activeTab === 'smtp' && isAdmin && (
            <>
              <SectionHeaderBar>
                <div className="title-block">
                  <h2>
                    <FiServer /> Servidor SMTP do Projeto (Criptografado em Banco)
                  </h2>
                  <p>
                    Configure o servidor de disparo de e-mails do GID. A senha SMTP é criptografada
                    com <strong>AES-256-GCM</strong> antes de ser persistida na tabela{' '}
                    <code>dbo.GID_CONFIG_SMTP</code>.
                  </p>
                </div>
                <div className="actions-block">
                  <ActionBtn
                    type="button"
                    $variant="primary"
                    onClick={() => setSmtpModalOpen(true)}
                  >
                    <FiEdit2 /> {smtpConfigured ? 'Editar Servidor SMTP' : 'Configurar SMTP'}
                  </ActionBtn>
                </div>
              </SectionHeaderBar>

              <SurfaceCard>
                <strong style={{ fontSize: 14 }}>
                  Credenciais SMTP Armazenadas no Banco de Dados
                </strong>

                <DataTableWrapper>
                  <StyledTable>
                    <thead>
                      <tr>
                        <th>Host SMTP</th>
                        <th>Porta & Segurança</th>
                        <th>Usuário Autenticado</th>
                        <th>Remetente (From)</th>
                        <th>Senha Criptografada (Banco)</th>
                        <th>Status</th>
                        <th>Atualizado em</th>
                        <th style={{ textAlign: 'right' }}>Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!smtpConfigured ? (
                        <tr>
                          <td colSpan={8} style={{ textAlign: 'center', padding: '26px 16px' }}>
                            Nenhum servidor SMTP configurado no banco ainda. Clique em{' '}
                            <strong>"Configurar SMTP"</strong> para cadastrar.
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td>
                            <strong>{smtpHost}</strong>
                          </td>
                          <td>
                            <code>Porta {smtpPort}</code> (
                            {Number(smtpPort) === 465 ? 'SSL/TLS Direto' : 'STARTTLS'})
                          </td>
                          <td>{smtpUser}</td>
                          <td>{smtpFrom || smtpUser}</td>
                          <td>
                            <CipherBadge>
                              <FiLock /> AES-256-GCM: {smtpEncryptedPreview || 'enc_v1:••••••••'}
                            </CipherBadge>
                          </td>
                          <td>
                            <StatusTag $active={smtpConfigured}>✔ Ativo e Criptografado</StatusTag>
                          </td>
                          <td>
                            {smtpUpdatedAt
                              ? new Date(smtpUpdatedAt).toLocaleString('pt-BR')
                              : 'Configurado'}
                          </td>
                          <td style={{ textAlign: 'right' }}>
                            <ActionBtn
                              type="button"
                              $variant="secondary"
                              $small
                              onClick={() => setSmtpModalOpen(true)}
                            >
                              <FiEdit2 /> Editar SMTP
                            </ActionBtn>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </StyledTable>
                </DataTableWrapper>

                {/* Painel rápido de teste de conexão SMTP */}
                <div
                  style={{
                    marginTop: 8,
                    padding: 16,
                    borderRadius: 12,
                    border: '1px solid rgba(59, 130, 246, 0.3)',
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    gap: 12,
                  }}
                >
                  <FieldGroup style={{ flex: 1, minWidth: 260 }}>
                    <label>Testar Disparo do Servidor SMTP em Tempo Real</label>
                    <StyledInput
                      type="email"
                      placeholder="Digite o e-mail que receberá o teste SMTP..."
                      value={smtpTestEmail}
                      onChange={(e) => setSmtpTestEmail(e.target.value)}
                    />
                  </FieldGroup>
                  <ActionBtn
                    type="button"
                    $variant="success"
                    onClick={handleTestarSmtp}
                    disabled={testingSmtp || !smtpConfigured}
                  >
                    <FiSend /> {testingSmtp ? 'Testando Conexão...' : 'Disparar E-mail de Teste'}
                  </ActionBtn>
                </div>
              </SurfaceCard>
            </>
          )}

          {/* ===================================================================
              SEÇÃO 5: DOCS DETALHADO (ORGANIZADO POR SUB-ABAS TEMÁTICAS)
             =================================================================== */}
          {activeTab === 'docs' && (
            <>
              <SectionHeaderBar>
                <div className="title-block">
                  <h2>
                    <FiBookOpen /> Central de Documentação & Como Usar (Perfil:{' '}
                    {userRole.toUpperCase()})
                  </h2>
                  <p>
                    Selecione uma das abas abaixo para consultar o guia passo a passo de cada
                    módulo de forma organizada e direta.
                  </p>
                </div>
              </SectionHeaderBar>

              {/* BARRA DE SUB-ABAS DA DOCUMENTAÇÃO */}
              <DocsSubTabsBar>
                <DocsSubTabBtn
                  type="button"
                  $active={docSubTab === 'gisa_ai'}
                  onClick={() => setDocSubTab('gisa_ai')}
                >
                  <GidIaIcon size={16} />
                  <span>GID IA & Consultas</span>
                </DocsSubTabBtn>

                <DocsSubTabBtn
                  type="button"
                  $active={docSubTab === 'training_shortcuts'}
                  onClick={() => setDocSubTab('training_shortcuts')}
                >
                  <FiCpu />
                  <span>Treinamento & Atalhos (/comando)</span>
                </DocsSubTabBtn>

                <DocsSubTabBtn
                  type="button"
                  $active={docSubTab === 'api_auth'}
                  onClick={() => setDocSubTab('api_auth')}
                >
                  <FiKey />
                  <span>API Keys & Autenticação</span>
                  <span className="tab-badge">{maxRequestsPerKey} reqs</span>
                </DocsSubTabBtn>

                <DocsSubTabBtn
                  type="button"
                  $active={docSubTab === 'routes'}
                  onClick={() => setDocSubTab('routes')}
                >
                  <FiSliders />
                  <span>Catálogo de Rotas</span>
                  <span className="tab-badge">{docsFilteredRoutes.length}</span>
                </DocsSubTabBtn>

                <DocsSubTabBtn
                  type="button"
                  $active={docSubTab === 'reports_excel'}
                  onClick={() => setDocSubTab('reports_excel')}
                >
                  <FiMail />
                  <span>Relatórios E-mail & Planilha 7 Dias</span>
                </DocsSubTabBtn>

                {isAdmin && (
                  <DocsSubTabBtn
                    type="button"
                    $active={docSubTab === 'smtp_admin'}
                    onClick={() => setDocSubTab('smtp_admin')}
                  >
                    <FiServer />
                    <span>Servidor SMTP & Admin</span>
                  </DocsSubTabBtn>
                )}
              </DocsSubTabsBar>

              {/* ===============================================================
                  SUB-ABA 1: GISA IA & CONSULTAS ANALÍTICAS DINÂMICAS
                 =============================================================== */}
              {docSubTab === 'gisa_ai' && (
                <DocsCardsGrid>
                  <SurfaceCard>
                    <DocSectionBlock>
                      <h4>
                        <BsStars /> 1. Chaves de IA Privadas por Usuário (AES-256-GCM)
                      </h4>
                      <p>
                        Cada usuário cadastra sua própria chave de IA na aba{' '}
                        <strong>Chat GISA & IA</strong> clicando em{' '}
                        <strong>"+ Adicionar Chave de IA"</strong>.
                      </p>
                      <ul>
                        <li>
                          <strong>Provedores Suportados:</strong> Google Gemini, OpenAI, Groq,
                          Anthropic Claude e OpenRouter (com digitação livre de modelo).
                        </li>
                        <li>
                          <strong>Isolamento Estrito por Conta:</strong> Sua API Key é vinculada ao
                          seu <code>user_id</code> na tabela <code>dbo.GID_USER_AI_CONFIG</code> e
                          criptografada com <strong>AES-256-GCM</strong>. Nenhum outro usuário vê
                          ou consome créditos da sua chave.
                        </li>
                        <li>
                          <strong>Fallback Analítico Nativo:</strong> Mesmo se o provedor externo de
                          IA oscilar, o <strong>Motor Analítico SQL Interno da GISA</strong>{' '}
                          processa sua pergunta diretamente no banco do GID.
                        </li>
                      </ul>
                    </DocSectionBlock>
                  </SurfaceCard>

                  <SurfaceCard>
                    <DocSectionBlock>
                      <h4>
                        <FiCpu /> 2. Consultas Analíticas Mês a Mês & Exportação Limpa
                      </h4>
                      <p>
                        Peça no Chat ou no Drawer flutuante a evolução de qualquer{' '}
                        <strong>Distribuidor, Marca, Família, SKU ou Cliente/PDV</strong>:
                      </p>
                      <pre>{`"Quero ver a evolução do sellout da Hotbel desde janeiro até o dia de hoje"
"Evolução mensal da marca Refreskant no semestre"
"Como está o faturamento da família Macarrão este ano?"`}</pre>
                      <ul>
                        <li>
                          <strong>Série Histórica Mensal:</strong> Calcula faturamento R$, volume em
                          itens/caixas, PDVs positivados, variação <code>% MoM</code> e Top 8
                          Produtos/Distribuidores.
                        </li>
                        <li>
                          <strong>Gráfico Interativo & Exportação Full HD:</strong> Alterne entre
                          Barras, Linhas e Área, abra em <strong>Tela Cheia (Widescreen)</strong> e
                          baixe a imagem <strong>PNG Full HD (1600×900px)</strong> contendo apenas o
                          gráfico limpo e os KPIs (sem botões ou barras de rolagem), ou exporte para{' '}
                          <strong>Excel (.xlsx)</strong>.
                        </li>
                        <li>
                          <strong>🛡️ Guardrail Zero-Trust:</strong> A GISA atua em modo{' '}
                          <strong>Read-Only</strong> sobre indicadores comerciais e bloqueia
                          qualquer tentativa de extrair senhas, hashes, tokens, API Keys, variáveis{' '}
                          <code>.env</code> ou comandos destrutivos.
                        </li>
                      </ul>
                    </DocSectionBlock>
                  </SurfaceCard>
                </DocsCardsGrid>
              )}

              {/* ===============================================================
                  SUB-ABA 2: TREINAMENTO COMPARTILHADO & ATALHOS PESSOAIS
                 =============================================================== */}
              {docSubTab === 'training_shortcuts' && (
                <DocsCardsGrid>
                  <SurfaceCard>
                    <DocSectionBlock>
                      <h4>
                        <FiBookOpen /> 1. Treinamento Compartilhado da GISA (Para Toda a Equipe)
                      </h4>
                      <p>
                        Tudo o que a GISA aprende em <code>dbo.GID_GISA_TRAINING</code> fica
                        disponível para <strong>todos os usuários do GID</strong>, sem expor sua API
                        Key privada.
                      </p>
                      <ul>
                        <li>
                          <strong>Auto-Captura do Histórico:</strong> Quando um usuário digita uma
                          pergunta que a GISA ainda não sabe responder, ela é salva automaticamente
                          como <strong>"Pendente de Treino (Histórico)"</strong> na aba{' '}
                          <strong>Chat GISA & IA</strong>.
                        </li>
                        <li>
                          <strong>Como Ensinar a GISA (Passo a Passo):</strong>
                          <ol>
                            <li>
                              Na aba <strong>Chat GISA & IA</strong>, localize a tabela{' '}
                              <strong>"Aprendizado Contínuo & Treinamento Compartilhado"</strong>.
                            </li>
                            <li>
                              Clique em <strong>"🎓 Ensinar à GISA"</strong> na pergunta pendente ou
                              em <strong>"+ Ensinar Nova Função à GISA"</strong>.
                            </li>
                            <li>
                              Escolha a <strong>Função do Sistema</strong> (<em>Sellout,
                              Regularidade 7 Dias, Estoque, PDVs, PDF, Excel</em> ou{' '}
                              <em>Resposta Customizada</em>), vincule o{' '}
                              <strong>Distribuidor/Marca Alvo</strong> e defina a{' '}
                              <strong>Janela Padrão</strong>.
                            </li>
                            <li>
                              Preencha a orientação em <strong>"Como a GISA deve responder"</strong>{' '}
                              e salve. Toda a equipe passa a contar com essa regra imediatamente!
                            </li>
                          </ol>
                        </li>
                      </ul>
                    </DocSectionBlock>
                  </SurfaceCard>

                  <SurfaceCard>
                    <DocSectionBlock>
                      <h4>
                        <FiSliders /> 2. Meus Atalhos Rápidos (<code>/comando</code>) Separados por
                        Usuário
                      </h4>
                      <p>
                        Diferente do treinamento (que é compartilhado), seus atalhos em{' '}
                        <code>dbo.GID_GISA_USER_SHORTCUTS</code> são{' '}
                        <strong>100% individuais e exclusivos da sua conta</strong>.
                      </p>
                      <ul>
                        <li>
                          <strong>Passo a Passo para Criar Seus Atalhos:</strong>
                          <ol>
                            <li>
                              Na aba <strong>Chat GISA & IA</strong>, vá até{' '}
                              <strong>"Meus Atalhos Rápidos & Padrões Pessoais"</strong> e clique em{' '}
                              <strong>"+ Novo Atalho Pessoal"</strong>.
                            </li>
                            <li>
                              Defina o comando (ex: <code>/hotbel</code> ou{' '}
                              <code>/meu-fechamento</code>), o nome do botão, a função padrão, o
                              período padrão (<em>Mês Atual, 3 Meses, 6 Meses ou Anual</em>) e o
                              prompt automático.
                            </li>
                            <li>
                              Marque <strong>"Fixar na barra rápida da GISA"</strong> para exibir o
                              botão no topo do Drawer Flutuante da GISA e no menu <code>/</code> do
                              chat.
                            </li>
                          </ol>
                        </li>
                        <li>
                          <strong>Resumo da Separação:</strong>
                          <ul>
                            <li>
                              🔒 <strong>Chave de IA:</strong> Privada do seu usuário.
                            </li>
                            <li>
                              🌐 <strong>Treinamento da GISA:</strong> Compartilhado com toda a
                              equipe.
                            </li>
                            <li>
                              ⚡ <strong>Atalhos e Padrões:</strong> Separados e individuais por
                              usuário.
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </DocSectionBlock>
                  </SurfaceCard>
                </DocsCardsGrid>
              )}

              {/* ===============================================================
                  SUB-ABA 3: API KEYS & AUTENTICAÇÃO (100 REQUISIÇÕES)
                 =============================================================== */}
              {docSubTab === 'api_auth' && (
                <SurfaceCard>
                  <DocSectionBlock>
                    <h4>
                      <FiKey /> Autenticação via API Key & Regra de Limite ({maxRequestsPerKey}{' '}
                      Requisições)
                    </h4>
                    <p>
                      Para integrar o GID a ferramentas externas (Power BI, Excel Web, Python, n8n
                      ou ERPs), gere uma chave na aba <strong>API Keys & Rotas</strong> e envie no
                      cabeçalho <code>x-api-key</code> ou{' '}
                      <code>Authorization: Bearer gid_live_...</code>.
                    </p>
                    <ul>
                      <li>
                        <strong>Limite Universal de Segurança:</strong> Toda API Key possui teto de{' '}
                        <strong>{maxRequestsPerKey} requisições</strong> (aplicável a Administrador,
                        Suporte e Conferente). Ao atingir {maxRequestsPerKey} chamadas, a API
                        retorna <code>HTTP 429</code>.
                      </li>
                      <li>
                        <strong>Escopo do seu Perfil ({userRole.toUpperCase()}):</strong>{' '}
                        {rolePolicyDesc}
                      </li>
                    </ul>
                    <pre>{`# Exemplo 1: Chamada HTTP via cURL usando cabeçalho x-api-key
curl -X GET "${window.location.origin}/v2/gid/get/sellout/sum" \\
  -H "x-api-key: gid_live_SUA_CHAVE_AQUI" \\
  -H "Content-Type: application/json"

# Exemplo 2: Chamada HTTP usando Authorization Bearer
curl -X GET "${window.location.origin}/v2/gid/integracoes/gisa/resumo" \\
  -H "Authorization: Bearer gid_live_SUA_CHAVE_AQUI"`}</pre>
                  </DocSectionBlock>
                </SurfaceCard>
              )}

              {/* ===============================================================
                  SUB-ABA 4: CATÁLOGO DE ROTAS PERMITIDAS AO PERFIL
                 =============================================================== */}
              {docSubTab === 'routes' && (
                <SurfaceCard>
                  <DocSectionBlock>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: 12,
                      }}
                    >
                      <h4>
                        <FiSliders /> Referência Detalhada de Rotas Permitidas ao Seu Perfil (
                        {docsFilteredRoutes.length} rotas)
                      </h4>
                      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                        {(
                          ['ALL', 'GET', 'POST', ...(isAdmin ? ['PUT', 'DELETE'] : [])] as const
                        ).map((m) => (
                          <MethodTabBtn
                            key={m}
                            type="button"
                            $active={docMethodFilter === m}
                            onClick={() => setDocMethodFilter(m as any)}
                          >
                            {m === 'ALL' ? 'Todos os Métodos' : m}
                          </MethodTabBtn>
                        ))}
                      </div>
                    </div>

                    <StyledInput
                      type="text"
                      placeholder="Filtrar documentação de rotas por endpoint, módulo ou descrição..."
                      value={docSearch}
                      onChange={(e) => setDocSearch(e.target.value)}
                    />

                    <DataTableWrapper>
                      <StyledTable>
                        <thead>
                          <tr>
                            <th>Método</th>
                            <th>Endpoint Completo</th>
                            <th>Módulo / Categoria</th>
                            <th>Como Usar (Parâmetros / Body)</th>
                            <th>Exemplo de Payload / Query</th>
                            <th style={{ textAlign: 'right' }}>Copiar cURL</th>
                          </tr>
                        </thead>
                        <tbody>
                          {docsFilteredRoutes.map((rt) => {
                            const fullUrl = `${window.location.origin}/v2/gid${
                              rt.path === '*' ? '/get/sellout/sum' : rt.path
                            }`
                            const curlCmd =
                              rt.method === 'GET'
                                ? `curl -X GET "${fullUrl}" -H "x-api-key: SUA_API_KEY"`
                                : `curl -X ${rt.method} "${fullUrl}" -H "x-api-key: SUA_API_KEY" -H "Content-Type: application/json" -d '${
                                    rt.examplePayloadOrQuery || '{}'
                                  }'`

                            return (
                              <tr key={rt.id}>
                                <td>
                                  <MethodBadge $method={rt.method}>{rt.method}</MethodBadge>
                                </td>
                                <td>
                                  <code style={{ fontWeight: 800, fontSize: 12 }}>
                                    /v2/gid{rt.path}
                                  </code>
                                  <div style={{ fontSize: 11, opacity: 0.8, marginTop: 2 }}>
                                    {rt.label}
                                  </div>
                                </td>
                                <td>
                                  <strong>{rt.module}</strong>
                                  <div style={{ fontSize: 11, opacity: 0.75 }}>
                                    Escopo: {rt.category.toUpperCase()}
                                  </div>
                                </td>
                                <td style={{ maxWidth: 300 }}>
                                  <div style={{ fontSize: 12 }}>{rt.description}</div>
                                  {rt.paramsDoc && (
                                    <div
                                      style={{
                                        fontSize: 11,
                                        opacity: 0.85,
                                        marginTop: 4,
                                        fontWeight: 600,
                                      }}
                                    >
                                      📌 {rt.paramsDoc}
                                    </div>
                                  )}
                                </td>
                                <td>
                                  <code style={{ fontSize: 11 }}>
                                    {rt.examplePayloadOrQuery || 'Sem parâmetros obrigatórios'}
                                  </code>
                                </td>
                                <td style={{ textAlign: 'right' }}>
                                  <ActionBtn
                                    type="button"
                                    $variant="secondary"
                                    $small
                                    onClick={() => copiarTexto(curlCmd, `cURL ${rt.id}`)}
                                  >
                                    <FiCopy /> Copiar cURL
                                  </ActionBtn>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </StyledTable>
                    </DataTableWrapper>
                  </DocSectionBlock>
                </SurfaceCard>
              )}

              {/* ===============================================================
                  SUB-ABA 5: RELATÓRIOS POR E-MAIL & PLANILHA REGULARIDADE 7 DIAS
                 =============================================================== */}
              {docSubTab === 'reports_excel' && (
                <DocsCardsGrid>
                  <SurfaceCard>
                    <DocSectionBlock>
                      <h4>
                        <FiMail /> 1. Agendamento de Relatórios por E-mail (PDF, CSV e EXCEL)
                      </h4>
                      <ul>
                        <li>
                          Na aba <strong>Relatório Diário (E-mail)</strong>, clique em{' '}
                          <strong>"+ Novo Relatório por E-mail"</strong>.
                        </li>
                        <li>
                          Informe o <strong>Nome do Agendamento</strong>, o{' '}
                          <strong>E-mail Principal</strong>, os destinatários em{' '}
                          <strong>Cópia (CC)</strong>, o <strong>Horário</strong> e a{' '}
                          <strong>Frequência</strong> (<em>Diário, Semanal ou Mensal</em>).
                        </li>
                        <li>
                          No <strong>Sub-Modal 1 (Telas, Relatórios e Formato)</strong>, escolha
                          quais relatórios deseja receber e marque os formatos de anexo:{' '}
                          <strong>PDF</strong>, <strong>CSV</strong> e/ou <strong>EXCEL</strong>.
                        </li>
                        <li>
                          No <strong>Sub-Modal 2 (Distribuidores e Período)</strong>, filtre{' '}
                          <strong>Todos os Distribuidores</strong> ou distribuidores específicos e
                          escolha a janela: <em>Por Mês, 3 Meses, 6 Meses ou Anual</em>.
                        </li>
                      </ul>
                    </DocSectionBlock>
                  </SurfaceCard>

                  <SurfaceCard>
                    <DocSectionBlock>
                      <h4>
                        <FiFileText /> 2. Aba Corporativa <code>Regularidade_Envios</code> (Semáforo
                        de 7 Dias)
                      </h4>
                      <p>
                        As planilhas corporativas geradas pela GISA e pelos relatórios de e-mail
                        incluem a aba <code>Regularidade_Envios</code> espelhando o painel visual de
                        Regularidade:
                      </p>
                      <ul>
                        <li>
                          <strong>7 Colunas Diárias (<code>DD/MM (Dia)</code>):</strong> Exibe cada
                          um dos últimos 7 dias com semáforo colorido:
                          <ul>
                            <li>
                              <code>🟢 Enviado</code> (Fundo verde suave e texto verde)
                            </li>
                            <li>
                              <code>🔴 Pendente</code> (Fundo vermelho suave e texto vermelho)
                            </li>
                            <li>
                              <code>🟠 Justificado</code> (Fundo laranja suave e texto laranja)
                            </li>
                            <li>
                              <code>⚪ Domingo</code> (Dia não útil em cinza neutro)
                            </li>
                          </ul>
                        </li>
                        <li>
                          <strong>Coluna "Gráfico 7 Dias (Visual)":</strong> Mostra a sequência de
                          bolinhas (ex: <code>🟢 🟢 🟢 🟢 ⚪ 🟢 🟢</code>) para leitura rápida.
                        </li>
                        <li>
                          <strong>Coluna "Situação Regular (Por Escrito)":</strong> Traz o
                          diagnóstico completo por extenso (ex:{' '}
                          <code>🟢 REGULAR — Em dia (6/6 dias úteis — 100%)</code> ou{' '}
                          <code>🔴 IRREGULAR / PENDENTE</code>).
                        </li>
                      </ul>
                    </DocSectionBlock>
                  </SurfaceCard>
                </DocsCardsGrid>
              )}

              {/* ===============================================================
                  SUB-ABA 6: SERVIDOR SMTP & GOVERNANÇA (EXCLUSIVO ADMIN)
                 =============================================================== */}
              {docSubTab === 'smtp_admin' && isAdmin && (
                <SurfaceCard>
                  <DocSectionBlock>
                    <h4>
                      <FiServer /> Configuração de Servidor SMTP Criptografado & Governança Admin
                    </h4>
                    <ul>
                      <li>
                        <strong>Exclusividade de Perfil:</strong> Apenas usuários com perfil{' '}
                        <strong>Administrador</strong> visualizam a aba{' '}
                        <strong>Servidor SMTP</strong> e as rotas administrativas (<code>PUT</code>,{' '}
                        <code>DELETE</code> e <code>/admin/*</code>).
                      </li>
                      <li>
                        <strong>Cofre Criptografado em Banco (<code>dbo.GID_CONFIG_SMTP</code>):</strong>{' '}
                        A senha do servidor SMTP é criptografada com <strong>AES-256-GCM</strong>{' '}
                        (prefixo autenticador <code>enc_v1:</code>) antes de ser persistida no SQL
                        Server, sendo descriptografada exclusivamente em memória no instante do
                        disparo via Nodemailer.
                      </li>
                      <li>
                        <strong>Portas & TLS Automático:</strong> A porta <code>465</code> utiliza
                        SSL/TLS direto automaticamente, enquanto a porta <code>587</code> utiliza
                        STARTTLS. Use o botão <strong>"Disparar E-mail de Teste"</strong> na aba
                        Servidor SMTP para validar a autenticação em tempo real.
                      </li>
                    </ul>
                  </DocSectionBlock>
                </SurfaceCard>
              )}
            </>
          )}
        </HubMainArea>
      </HubLayout>

      {/* =====================================================================
          MODAL 1: CRIAR / EDITAR API KEY
         ===================================================================== */}
      {apiKeyModalOpen && (
        <ModalOverlay onClick={() => setApiKeyModalOpen(false)}>
          <ModalCard $maxWidth="650px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiKey /> {editingApiKeyId ? 'Editar API Key & Rotas' : 'Criar Nova API Key'}
                </h3>
                <span>
                  Limite fixo de segurança: {maxRequestsPerKey} requisições por chave (todos os
                  perfis)
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setApiKeyModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FormRow>
                <FieldGroup>
                  <label>Nome de Identificação da API Key</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: Integração Power BI / ERP Comercial"
                    value={keyName}
                    onChange={(e) => setKeyName(e.target.value)}
                  />
                </FieldGroup>

                <FieldGroup>
                  <label>Prazo de Expiração</label>
                  <StyledSelect
                    value={expiresInDays}
                    onChange={(e) => setExpiresInDays(e.target.value)}
                    disabled={Boolean(editingApiKeyId)}
                  >
                    <option value="0">Sem data de expiração (Até 100 requisições)</option>
                    <option value="30">Expira em 30 dias (ou 100 requisições)</option>
                    <option value="90">Expira em 90 dias (ou 100 requisições)</option>
                    <option value="180">Expira em 180 dias (ou 100 requisições)</option>
                    <option value="365">Expira em 365 dias (ou 100 requisições)</option>
                  </StyledSelect>
                </FieldGroup>
              </FormRow>

              <div
                style={{
                  padding: '12px 14px',
                  borderRadius: 10,
                  background: 'rgba(245, 158, 11, 0.12)',
                  border: '1px solid rgba(245, 158, 11, 0.35)',
                  fontSize: 12,
                  lineHeight: 1.5,
                }}
              >
                <strong>🔒 Governança de Requisições:</strong> Esta API Key terá limite máximo de{' '}
                <strong>{maxRequestsPerKey} requisições</strong>. Perfil vinculado:{' '}
                <strong>{userRole.toUpperCase()}</strong>.
              </div>

              {/* Botão que abre o Sub-Modal ("Modal do Modal") de Seleção de Rotas */}
              <SubModalTriggerCard>
                <div className="info">
                  <strong>Rotas Vinculadas a Esta API Key ({selectedRoutes.length})</strong>
                  <span>
                    {selectedRoutes.length === 0
                      ? 'Nenhuma rota selecionada ainda. Clique ao lado para escolher as rotas.'
                      : `Selecionadas: ${selectedRoutes.slice(0, 4).join(', ')}${
                          selectedRoutes.length > 4 ? ` e mais +${selectedRoutes.length - 4}` : ''
                        }`}
                  </span>
                </div>
                <ActionBtn
                  type="button"
                  $variant="primary"
                  onClick={() => {
                    setMethodTab('ALL_METHODS')
                    setRouteSearch('')
                    setRoutesSubModalOpen(true)
                  }}
                >
                  <FiSliders /> Selecionar Rotas ({selectedRoutes.length})
                </ActionBtn>
              </SubModalTriggerCard>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="secondary"
                onClick={() => setApiKeyModalOpen(false)}
              >
                Cancelar
              </ActionBtn>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={handleSalvarApiKeyModal}
                disabled={savingApiKey}
              >
                <FiCheckCircle />{' '}
                {savingApiKey
                  ? 'Salvando...'
                  : editingApiKeyId
                    ? 'Salvar Alterações'
                    : 'Gerar API Key (100 Reqs)'}
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          SUB-MODAL ("MODAL DO MODAL"): SELECIONAR ROTAS POR MÉTODO HTTP
          Admin: GET, POST, PUT, DELETE, ALL (*)
          Suporte: GET, POST (apenas consulta e publicação)
          Conferente: GET, POST (apenas consulta)
         ===================================================================== */}
      {routesSubModalOpen && (
        <ModalOverlay $zIndex={1250} onClick={() => setRoutesSubModalOpen(false)}>
          <ModalCard $maxWidth="840px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiSliders /> Selecionar Rotas da API Key ({userRole.toUpperCase()})
                </h3>
                <span>
                  {isAdmin
                    ? 'Administrador: acesso completo aos menus GET, POST, PUT, DEL e Acesso Total (*).'
                    : isSuporte
                      ? 'Suporte: acesso aos menus GET e POST limitados às rotas de consulta e publicação operacional (sem rotas Admin).'
                      : 'Conferente: acesso aos menus GET e POST limitados estritamente às rotas de consulta.'}
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setRoutesSubModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              {/* Abas por Método HTTP (GET, POST, PUT, DEL) */}
              <MethodTabsBar>
                {allowedMethodTabs.map((tab) => {
                  const countInTab =
                    tab.id === 'ALL_METHODS'
                      ? routesCatalog.length
                      : routesCatalog.filter((r) => r.method === tab.id).length
                  return (
                    <MethodTabBtn
                      key={tab.id}
                      type="button"
                      $active={methodTab === tab.id}
                      onClick={() => setMethodTab(tab.id as any)}
                    >
                      <span>{tab.label}</span>
                      <span className="count-pill">{countInTab}</span>
                    </MethodTabBtn>
                  )
                })}
              </MethodTabsBar>

              <div
                style={{
                  display: 'flex',
                  gap: 10,
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                <div style={{ flex: 1, minWidth: 240 }}>
                  <StyledInput
                    type="text"
                    placeholder="Buscar rota por caminho (/sellout, /estoque), módulo ou descrição..."
                    value={routeSearch}
                    onChange={(e) => setRouteSearch(e.target.value)}
                  />
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    $small
                    onClick={() => {
                      const visibleIds = filteredRoutesForSubModal.map((r) => r.id)
                      setSelectedRoutes((prev) => Array.from(new Set([...prev, ...visibleIds])))
                    }}
                  >
                    Marcar Visíveis ({filteredRoutesForSubModal.length})
                  </ActionBtn>
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    $small
                    onClick={() => setSelectedRoutes([])}
                  >
                    Limpar Seleção
                  </ActionBtn>
                </div>
              </div>

              <RouteSelectorBox>
                {filteredRoutesForSubModal.map((route) => {
                  const isChecked = selectedRoutes.includes(route.id)
                  return (
                    <RouteItemLabel key={route.id} $checked={isChecked}>
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => toggleRouteSelection(route.id)}
                      />
                      <div className="route-info">
                        <div className="top-line">
                          <MethodBadge $method={route.method}>{route.method}</MethodBadge>
                          <span className="route-path">/v2/gid{route.path}</span>
                          <span style={{ fontSize: 11, fontWeight: 700, opacity: 0.75 }}>
                            • {route.module} ({route.category.toUpperCase()})
                          </span>
                        </div>
                        <div className="route-desc">
                          <strong>{route.label}:</strong> {route.description}
                        </div>
                      </div>
                    </RouteItemLabel>
                  )
                })}
              </RouteSelectorBox>

              {canAddCustomRoute && (
                <div
                  style={{
                    display: 'flex',
                    gap: 8,
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    paddingTop: 6,
                  }}
                >
                  <StyledSelect
                    style={{ width: 130 }}
                    value={customRouteMethod}
                    onChange={(e) => setCustomRouteMethod(e.target.value as any)}
                  >
                    <option value="GET">GET</option>
                    <option value="POST">POST</option>
                    <option value="PUT">PUT</option>
                    <option value="DELETE">DELETE</option>
                    <option value="ALL">ALL (*)</option>
                  </StyledSelect>
                  <StyledInput
                    style={{ flex: 1 }}
                    type="text"
                    placeholder="Adicionar rota customizada (Admin) — Ex: /meu-endpoint"
                    value={customRoutePath}
                    onChange={(e) => setCustomRoutePath(e.target.value)}
                  />
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    onClick={handleAddCustomAdminRoute}
                  >
                    <FiPlus /> Incluir Rota
                  </ActionBtn>
                </div>
              )}
            </ModalBody>

            <ModalFooter>
              <span style={{ marginRight: 'auto', fontSize: 12, fontWeight: 700 }}>
                Total de rotas marcadas: {selectedRoutes.length}
              </span>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={() => setRoutesSubModalOpen(false)}
              >
                <FiCheckCircle /> Confirmar Rotas Selecionadas ({selectedRoutes.length})
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          MODAL 2: ADICIONAR / EDITAR CHAVE DE IA CRIPTOGRAFADA (GISA)
         ===================================================================== */}
      {aiModalOpen && (
        <ModalOverlay onClick={() => setAiModalOpen(false)}>
          <ModalCard $maxWidth="600px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiCpu />{' '}
                  {editingAiKeyId
                    ? 'Editar Chave de IA Criptografada'
                    : 'Adicionar Nova Chave de IA (GISA)'}
                </h3>
                <span>Criptografia autenticada AES-256-GCM em banco de dados</span>
              </div>
              <button type="button" className="close-btn" onClick={() => setAiModalOpen(false)}>
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FieldGroup>
                <label>Nome / Identificação da Chave</label>
                <StyledInput
                  type="text"
                  placeholder="Ex: Chave Gemini Flash Comercial"
                  value={aiKeyName}
                  onChange={(e) => setAiKeyName(e.target.value)}
                />
              </FieldGroup>

              <FormRow>
                <FieldGroup>
                  <label>Provedor de IA</label>
                  <StyledSelect
                    value={aiProvider}
                    onChange={(e) => setAiProvider(e.target.value)}
                  >
                    {aiProviders.map((prov) => (
                      <option key={prov.id} value={prov.id}>
                        {prov.name}
                      </option>
                    ))}
                  </StyledSelect>
                </FieldGroup>

                <FieldGroup>
                  <label>Modelo da IA (Digite o modelo)</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: gemini-2.5-flash, gpt-4o, llama-3.3-70b-versatile..."
                    value={aiModel}
                    onChange={(e) => setAiModel(e.target.value)}
                  />
                </FieldGroup>
              </FormRow>

              <FieldGroup>
                <label>
                  API Key Secreta do Provedor{' '}
                  {editingAiKeyId && '(Deixe em branco para manter a chave criptografada atual)'}
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <StyledInput
                    type={showAiKey ? 'text' : 'password'}
                    placeholder={
                      editingAiKeyId
                        ? '•••••••• (Chave já criptografada com AES-256-GCM)'
                        : 'Cole sua API Key (ex: AIzaSy... ou sk-...)'
                    }
                    value={aiApiKey}
                    onChange={(e) => setAiApiKey(e.target.value)}
                  />
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    onClick={() => setShowAiKey(!showAiKey)}
                  >
                    {showAiKey ? <FiEyeOff /> : <FiEye />}
                  </ActionBtn>
                </div>
              </FieldGroup>

              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={aiKeyIsActive}
                  onChange={(e) => setAiKeyIsActive(e.target.checked)}
                  style={{ width: 18, height: 18, accentColor: '#2563eb' }}
                />
                Definir como chave ativa principal para o Chat da GID IA
              </label>
            </ModalBody>

            <ModalFooter>
              <ActionBtn type="button" $variant="secondary" onClick={() => setAiModalOpen(false)}>
                Cancelar
              </ActionBtn>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={handleSalvarChaveIaModal}
                disabled={savingAi}
              >
                <FiCheckCircle />{' '}
                {savingAi ? 'Criptografando e Salvando...' : 'Salvar Chave Criptografada'}
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          MODAL 2.B: ENSINAR / TREINAR A GISA (COMPARTILHADO ENTRE USUÁRIOS)
         ===================================================================== */}
      {trainingModalOpen && (
        <ModalOverlay onClick={() => setTrainingModalOpen(false)}>
          <ModalCard $maxWidth="680px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <GidIaIcon size={20} />{' '}
                  {editingTrainingId
                    ? 'Ensinar / Ajustar Treinamento da GID IA'
                    : 'Ensinar Nova Função ou Regra à GID IA'}
                </h3>
                <span>
                  Este treinamento será compartilhado com os demais usuários do sistema (sua API Key
                  e seus atalhos continuam privados)
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setTrainingModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FieldGroup>
                <label>O que o usuário digita no Chat (Pergunta ou Comando Gatilho)</label>
                <StyledInput
                  type="text"
                  placeholder="Ex: Quero ver a evolução do sellout da hotbel desde janeiro até o dia de hoje"
                  value={trainingTriggerPhrase}
                  onChange={(e) => setTrainingTriggerPhrase(e.target.value)}
                />
              </FieldGroup>

              <FormRow>
                <FieldGroup>
                  <label>Qual Função do Sistema a GISA deve executar?</label>
                  <StyledSelect
                    value={trainingTargetAction}
                    onChange={(e) => setTrainingTargetAction(e.target.value)}
                  >
                    <option value="sellout">📈 Evolução & Ranking de Sellout (Faturamento / Volume)</option>
                    <option value="regularidade">🟢🔴 Auditoria de Regularidade (Últimos 7 Dias)</option>
                    <option value="estoque">📦 Diagnóstico de Estoque & Giro</option>
                    <option value="pdvs">🏪 Cobertura de Clientes / PDVs & IBGE</option>
                    <option value="pdf">📄 Geração de Relatório Executivo PDF</option>
                    <option value="excel">📊 Exportação de Planilha Corporativa Excel</option>
                    <option value="resposta_customizada">💬 Resposta / Orientação Direta Customizada</option>
                  </StyledSelect>
                </FieldGroup>

                <FieldGroup>
                  <label>Palavras-chave de Reconhecimento (Opcional)</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: hotbel, evolucao, sellout"
                    value={trainingKeywords}
                    onChange={(e) => setTrainingKeywords(e.target.value)}
                  />
                </FieldGroup>
              </FormRow>

              <FieldGroup>
                <label>
                  Vincular a qual Distribuidor, Marca ou Entidade do Banco? (Opcional — Digite ou
                  escolha abaixo)
                </label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  <StyledInput
                    type="text"
                    placeholder="Ex: Nome do Distribuidor, Marca ou Família no banco (ex: Compare Floresta)"
                    value={trainingEntityMapping}
                    onChange={(e) => setTrainingEntityMapping(e.target.value)}
                    style={{ flex: 1, minWidth: 240 }}
                  />
                  {distributorsCatalog.length > 0 && (
                    <StyledSelect
                      value=""
                      onChange={(e) => {
                        if (e.target.value) setTrainingEntityMapping(e.target.value)
                      }}
                      style={{ maxWidth: 240 }}
                    >
                      <option value="">Selecionar Distribuidor...</option>
                      {distributorsCatalog.map((d) => (
                        <option key={d.id} value={d.name}>
                          {d.name} ({d.uf})
                        </option>
                      ))}
                    </StyledSelect>
                  )}
                </div>
                <small style={{ fontSize: 11.5, opacity: 0.75 }}>
                  Se o usuário digitou um apelido ou marca (ex: "Hotbel"), vincule acima ao
                  Distribuidor ou Marca correspondente para que a GISA consulte os números reais no
                  SQL Server.
                </small>
              </FieldGroup>

              <FieldGroup>
                <label>
                  Como você deseja que a GISA responda ou execute esta função? (Instrução de
                  Treinamento)
                </label>
                <textarea
                  rows={4}
                  placeholder="Ex: Sempre mostre a evolução mês a mês desde Janeiro até hoje em R$ e caixas, destacando o melhor mês, o gráfico de evolução e o status de regularidade dos últimos 7 dias."
                  value={trainingExpectedBehavior}
                  onChange={(e) => setTrainingExpectedBehavior(e.target.value)}
                  style={{
                    width: '100%',
                    borderRadius: 10,
                    padding: '10px 12px',
                    fontSize: 13,
                    border: '1px solid rgba(148, 163, 184, 0.35)',
                    background: 'transparent',
                    color: 'inherit',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                  }}
                />
              </FieldGroup>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="secondary"
                onClick={() => setTrainingModalOpen(false)}
              >
                Cancelar
              </ActionBtn>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={handleSalvarTreinamentoModal}
                disabled={savingTraining}
              >
                <FiCheckCircle />{' '}
                {savingTraining ? 'Salvando Treinamento...' : 'Salvar e Ativar Treinamento na GID IA'}
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          MODAL 2.C: NOVO / EDITAR ATALHO PESSOAL DO USUÁRIO (ISOLADO POR CONTA)
         ===================================================================== */}
      {shortcutModalOpen && (
        <ModalOverlay onClick={() => setShortcutModalOpen(false)}>
          <ModalCard $maxWidth="620px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiSliders />{' '}
                  {editingShortcutId
                    ? 'Editar Meu Atalho & Padrão Pessoal'
                    : 'Criar Novo Atalho Pessoal na GID IA'}
                </h3>
                <span>
                  Exclusivo da sua conta ({user?.name || user?.nickname}) — fica visível apenas no
                  seu Chat da GID IA
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setShortcutModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FormRow>
                <FieldGroup>
                  <label>Comando Rápido (Iniciado por /)</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: /hotbel ou /meu-sellout"
                    value={shortcutCommand}
                    onChange={(e) => setShortcutCommand(e.target.value)}
                  />
                </FieldGroup>

                <FieldGroup>
                  <label>Nome do Botão Rápido no Chat</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: 📈 Sellout Hotbel"
                    value={shortcutLabel}
                    onChange={(e) => setShortcutLabel(e.target.value)}
                  />
                </FieldGroup>
              </FormRow>

              <FormRow>
                <FieldGroup>
                  <label>Função Padrão ao Clicar</label>
                  <StyledSelect
                    value={shortcutDefaultAction}
                    onChange={(e) => setShortcutDefaultAction(e.target.value)}
                  >
                    <option value="chat">💬 Enviar Pergunta Analítica no Chat</option>
                    <option value="sellout">📈 Abrir Diagnóstico de Sellout</option>
                    <option value="regularidade">🟢🔴 Auditar Regularidade 7 Dias</option>
                    <option value="estoque">📦 Diagnosticar Estoque</option>
                    <option value="pdvs">🏪 Analisar Cobertura de PDVs</option>
                    <option value="pdf">📄 Baixar PDF Executivo na Hora</option>
                    <option value="excel">📊 Baixar Planilha Excel na Hora</option>
                  </StyledSelect>
                </FieldGroup>

                <FieldGroup>
                  <label>Período Padrão Preferido</label>
                  <StyledSelect
                    value={shortcutDefaultPeriod}
                    onChange={(e) => setShortcutDefaultPeriod(e.target.value as any)}
                  >
                    <option value="anual">Anual (Desde Janeiro até Hoje)</option>
                    <option value="6_meses">Semestral (Últimos 6 Meses)</option>
                    <option value="3_meses">Trimestral (Últimos 3 Meses)</option>
                    <option value="mes_atual">Mês Atual</option>
                  </StyledSelect>
                </FieldGroup>
              </FormRow>

              <FieldGroup>
                <label>Pergunta ou Comando Padrão que será enviado à GISA</label>
                <textarea
                  rows={3}
                  placeholder="Ex: Quero ver a evolução do sellout da Hotbel desde janeiro até o dia de hoje"
                  value={shortcutPromptTemplate}
                  onChange={(e) => setShortcutPromptTemplate(e.target.value)}
                  style={{
                    width: '100%',
                    borderRadius: 10,
                    padding: '10px 12px',
                    fontSize: 13,
                    border: '1px solid rgba(148, 163, 184, 0.35)',
                    background: 'transparent',
                    color: 'inherit',
                    fontFamily: 'inherit',
                    resize: 'vertical',
                  }}
                />
              </FieldGroup>

              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={shortcutPinToBar}
                  onChange={(e) => setShortcutPinToBar(e.target.checked)}
                  style={{ width: 18, height: 18, accentColor: '#2563eb' }}
                />
                Fixar este botão na barra superior do meu Chat Flutuante da GISA
              </label>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="secondary"
                onClick={() => setShortcutModalOpen(false)}
              >
                Cancelar
              </ActionBtn>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={handleSalvarAtalhoPessoalModal}
                disabled={savingShortcut}
              >
                <FiCheckCircle />{' '}
                {savingShortcut ? 'Salvando...' : 'Salvar Meu Atalho Pessoal'}
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          MODAL 3: NOVO / EDITAR AGENDAMENTO DE RELATÓRIO POR E-MAIL
         ===================================================================== */}
      {emailModalOpen && (
        <ModalOverlay onClick={() => setEmailModalOpen(false)}>
          <ModalCard $maxWidth="700px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiMail />{' '}
                  {editingScheduleId
                    ? 'Editar Agendamento de Relatório por E-mail'
                    : 'Novo Relatório Programado por E-mail'}
                </h3>
                <span>
                  Defina destinatário, cópia (CC), horário, frequência, telas/formatos e
                  distribuidores
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setEmailModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FormRow>
                <FieldGroup>
                  <label>Nome do Agendamento</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: Fechamento Diário Diretoria & Comercial"
                    value={scheduleName}
                    onChange={(e) => setScheduleName(e.target.value)}
                  />
                </FieldGroup>

                <FieldGroup>
                  <label>E-mail Destinatário Principal</label>
                  <StyledInput
                    type="email"
                    placeholder="seu.email@empresa.com.br"
                    value={recipientEmail}
                    onChange={(e) => setRecipientEmail(e.target.value)}
                  />
                </FieldGroup>
              </FormRow>

              <FormRow>
                <FieldGroup>
                  <label>Frequência do Disparo</label>
                  <StyledSelect
                    value={frequency}
                    onChange={(e) => setFrequency(e.target.value as any)}
                  >
                    <option value="diario">Recorrente (Todos os dias)</option>
                    <option value="semanal">De Semana em Semana (Semanal)</option>
                    <option value="mensal">De Mês em Mês (Mensal)</option>
                  </StyledSelect>
                </FieldGroup>

                <FieldGroup>
                  <label>Horário Programado de Disparo</label>
                  <StyledInput
                    type="time"
                    value={sendTime}
                    onChange={(e) => setSendTime(e.target.value)}
                  />
                </FieldGroup>
              </FormRow>

              {/* E-mails em Cópia (CC Opcional) */}
              <FieldGroup>
                <label>Destinatários em Cópia — CC (Opcional)</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <StyledInput
                    type="email"
                    placeholder="Digite um e-mail para colocar em cópia e clique em Adicionar..."
                    value={ccInput}
                    onChange={(e) => setCcInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault()
                        handleAddCcEmail()
                      }
                    }}
                  />
                  <ActionBtn type="button" $variant="secondary" onClick={handleAddCcEmail}>
                    <FiPlus /> Adicionar CC
                  </ActionBtn>
                </div>
                {ccEmails.length > 0 && (
                  <CcChipList style={{ marginTop: 6 }}>
                    {ccEmails.map((email) => (
                      <span key={email} className="cc-chip">
                        {email}
                        <button
                          type="button"
                          onClick={() =>
                            setCcEmails((prev) => prev.filter((item) => item !== email))
                          }
                        >
                          <FiX />
                        </button>
                      </span>
                    ))}
                  </CcChipList>
                )}
              </FieldGroup>

              {/* Gatilho para Sub-Modal A: Escolher Telas, Relatórios e Formato (PDF, CSV, EXCEL) */}
              <SubModalTriggerCard>
                <div className="info">
                  <strong>
                    1. Telas, Relatórios & Formato do Anexo ({selectedReports.length} selecionados)
                  </strong>
                  <span>
                    Formatos escolhidos: <strong>{exportFormats.join(', ')}</strong> •{' '}
                    {selectedReports
                      .slice(0, 2)
                      .map((id) => reportsCatalog.find((r) => r.id === id)?.title || id)
                      .join(', ')}
                    {selectedReports.length > 2 ? ` +${selectedReports.length - 2}` : ''}
                  </span>
                </div>
                <ActionBtn
                  type="button"
                  $variant="primary"
                  onClick={() => setReportsSubModalOpen(true)}
                >
                  <FiFileText /> Escolher Telas, Relatórios & Formato
                </ActionBtn>
              </SubModalTriggerCard>

              {/* Gatilho para Sub-Modal B: Escolher Distribuidores e Período */}
              <SubModalTriggerCard>
                <div className="info">
                  <strong>2. Distribuidores & Período de Cálculo</strong>
                  <span>
                    Distribuidores:{' '}
                    <strong>
                      {selectedDistributorIds === 'ALL'
                        ? 'Todos os Distribuidores'
                        : `${selectedDistributorIds.length} selecionado(s)`}
                    </strong>{' '}
                    • Período: <strong>{formatPeriodLabel(periodWindow)}</strong>
                  </span>
                </div>
                <ActionBtn
                  type="button"
                  $variant="primary"
                  onClick={() => {
                    setDistSearch('')
                    if (distributorsCatalog.length === 0) {
                      garantirDistribuidoresCarregados(true)
                    }
                    setDistsSubModalOpen(true)
                  }}
                >
                  <FiFilter /> Escolher Distribuidores & Período
                </ActionBtn>
              </SubModalTriggerCard>

              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  fontSize: 13,
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={scheduleActive}
                  onChange={(e) => setScheduleActive(e.target.checked)}
                  style={{ width: 18, height: 18, accentColor: '#2563eb' }}
                />
                Agendamento ativo para disparo automático
              </label>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="secondary"
                onClick={() => setEmailModalOpen(false)}
              >
                Cancelar
              </ActionBtn>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={handleSalvarAgendamentoEmail}
                disabled={savingReport}
              >
                <FiCheckCircle />{' '}
                {savingReport ? 'Salvando...' : 'Salvar Agendamento de E-mail'}
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          SUB-MODAL A ("MODAL DO MODAL"): TELAS, RELATÓRIOS E FORMATO (PDF, CSV, EXCEL)
         ===================================================================== */}
      {reportsSubModalOpen && (
        <ModalOverlay $zIndex={1260} onClick={() => setReportsSubModalOpen(false)}>
          <ModalCard $maxWidth="760px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiFileText /> Escolher Telas, Relatórios e Formato do Anexo
                </h3>
                <span>
                  Selecione quais telas e relatórios do GID deseja receber e o formato (PDF, CSV ou
                  EXCEL)
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setReportsSubModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FieldGroup>
                <label>Formato(s) do Arquivo Anexo no E-mail (Pode marcar um ou mais)</label>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                  {(['PDF', 'CSV', 'EXCEL'] as const).map((fmt) => {
                    const active = exportFormats.includes(fmt)
                    return (
                      <MethodTabBtn
                        key={fmt}
                        type="button"
                        $active={active}
                        onClick={() => toggleExportFormat(fmt)}
                      >
                        <span>
                          {fmt === 'PDF'
                            ? '📄 PDF Executivo (.pdf)'
                            : fmt === 'CSV'
                              ? '📊 Planilha CSV (.csv)'
                              : '📗 Planilha Excel (.xls)'}
                        </span>
                      </MethodTabBtn>
                    )
                  })}
                </div>
              </FieldGroup>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 8,
                }}
              >
                <strong style={{ fontSize: 13 }}>
                  Telas do Sistema & Relatórios Executivos Disponíveis ({selectedReports.length}{' '}
                  marcados)
                </strong>
                <div style={{ display: 'flex', gap: 8 }}>
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    $small
                    onClick={() => setSelectedReports(reportsCatalog.map((r) => r.id))}
                  >
                    Marcar Todos
                  </ActionBtn>
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    $small
                    onClick={() => setSelectedReports(['resumo_executivo'])}
                  >
                    Apenas Resumo
                  </ActionBtn>
                </div>
              </div>

              <RouteSelectorBox>
                {reportsCatalog.map((rep) => {
                  const checked = selectedReports.includes(rep.id)
                  const isScreen = rep.id.startsWith('tela_')
                  return (
                    <RouteItemLabel key={rep.id} $checked={checked}>
                      <input
                        type="checkbox"
                        checked={checked}
                        onChange={() => toggleReportType(rep.id)}
                      />
                      <div className="route-info">
                        <div className="top-line">
                          <MethodBadge $method={isScreen ? 'POST' : 'GET'}>
                            {isScreen ? 'TELA' : 'RELATÓRIO'}
                          </MethodBadge>
                          <span className="route-path">{rep.title}</span>
                        </div>
                        <div className="route-desc">{rep.description}</div>
                      </div>
                    </RouteItemLabel>
                  )
                })}
              </RouteSelectorBox>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={() => setReportsSubModalOpen(false)}
              >
                <FiCheckCircle /> Confirmar Telas, Relatórios & Formatos ({exportFormats.join(', ')})
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          SUB-MODAL B ("MODAL DO MODAL"): DISTRIBUIDORES E PERÍODO
         ===================================================================== */}
      {distsSubModalOpen && (
        <ModalOverlay $zIndex={1260} onClick={() => setDistsSubModalOpen(false)}>
          <ModalCard $maxWidth="720px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiCalendar /> Escolher Distribuidores e Período do Relatório
                </h3>
                <span>
                  Defina se o relatório consolidará Todos os Distribuidores ou uma seleção
                  específica, e escolha o período
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setDistsSubModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FieldGroup>
                <label>Período de Apuração dos Dados</label>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {(
                    [
                      { id: 'mes_atual', label: '📅 Por Mês (Mês Atual)' },
                      { id: '3_meses', label: '📆 3 Meses (Trimestral)' },
                      { id: '6_meses', label: '📊 6 Meses (Semestral)' },
                      { id: 'anual', label: '🗓️ Anual (12 Meses)' },
                    ] as const
                  ).map((p) => (
                    <MethodTabBtn
                      key={p.id}
                      type="button"
                      $active={periodWindow === p.id}
                      onClick={() => setPeriodWindow(p.id)}
                    >
                      {p.label}
                    </MethodTabBtn>
                  ))}
                </div>
              </FieldGroup>

              <FieldGroup>
                <label>Escopo de Distribuidores (Todos ou Específicos)</label>
                <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                  <MethodTabBtn
                    type="button"
                    $active={selectedDistributorIds === 'ALL'}
                    onClick={() => setSelectedDistributorIds('ALL')}
                  >
                    ✅ Todos os Distribuidores ({distributorsCatalog.length})
                  </MethodTabBtn>
                  <MethodTabBtn
                    type="button"
                    $active={selectedDistributorIds !== 'ALL'}
                    onClick={() => {
                      if (selectedDistributorIds === 'ALL') {
                        const firstFew = distributorsCatalog.slice(0, 1).map((d) => d.id)
                        setSelectedDistributorIds(firstFew.length > 0 ? firstFew : [])
                      }
                    }}
                  >
                    🎯 Selecionar Específicos (
                    {selectedDistributorIds === 'ALL'
                      ? distributorsCatalog.length
                      : selectedDistributorIds.length}
                    )
                  </MethodTabBtn>
                  <ActionBtn
                    type="button"
                    $variant="secondary"
                    $small
                    onClick={() => garantirDistribuidoresCarregados(true)}
                  >
                    <FiRefreshCw /> Recarregar Distribuidores
                  </ActionBtn>
                </div>
              </FieldGroup>

              <FormRow>
                <FieldGroup>
                  <label>Selecionar / Adicionar Distribuidor pelo Select</label>
                  <StyledSelect
                    value=""
                    onChange={(e) => {
                      const val = e.target.value
                      if (!val) return
                      if (val === 'ALL') {
                        setSelectedDistributorIds('ALL')
                        return
                      }
                      const numId = Number(val)
                      if (!isNaN(numId) && numId > 0) {
                        setSelectedDistributorIds((prev) => {
                          if (prev === 'ALL') return [numId]
                          return prev.includes(numId) ? prev : [...prev, numId]
                        })
                      }
                    }}
                  >
                    <option value="">
                      -- Escolha um distribuidor para adicionar (ou Todos) --
                    </option>
                    <option value="ALL">✅ Incluir TODOS os Distribuidores ({distributorsCatalog.length})</option>
                    {distributorsCatalog.map((d) => (
                      <option key={d.id} value={d.id}>
                        #{d.id} — {d.name} {d.uf ? `(${d.uf})` : ''}
                      </option>
                    ))}
                  </StyledSelect>
                </FieldGroup>

                <FieldGroup>
                  <label>Buscar na Lista de Distribuidores</label>
                  <StyledInput
                    type="text"
                    placeholder="Filtrar por nome, regional ou CNPJ..."
                    value={distSearch}
                    onChange={(e) => setDistSearch(e.target.value)}
                  />
                </FieldGroup>
              </FormRow>

              <RouteSelectorBox>
                {distributorsCatalog.length === 0 ? (
                  <div style={{ padding: '20px', textAlign: 'center', fontSize: 13 }}>
                    Nenhum distribuidor carregado ainda. Clique em{' '}
                    <strong>"Recarregar Distribuidores"</strong> acima.
                  </div>
                ) : (
                  distributorsCatalog
                    .filter((d) => {
                      if (!distSearch.trim()) return true
                      const q = distSearch.toLowerCase()
                      return (
                        d.name.toLowerCase().includes(q) ||
                        d.uf.toLowerCase().includes(q) ||
                        d.cnpj.toLowerCase().includes(q)
                      )
                    })
                    .map((dist) => {
                      const isChecked =
                        selectedDistributorIds === 'ALL' ||
                        selectedDistributorIds.includes(dist.id)
                      return (
                        <RouteItemLabel key={dist.id} $checked={isChecked}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => toggleDistributorSelection(dist.id)}
                          />
                          <div className="route-info">
                            <div className="top-line">
                              <span className="route-path">
                                #{dist.id} — {dist.name}
                              </span>
                              {dist.uf && <MethodBadge $method="GET">{dist.uf}</MethodBadge>}
                            </div>
                            {dist.cnpj && <div className="route-desc">CNPJ: {dist.cnpj}</div>}
                          </div>
                        </RouteItemLabel>
                      )
                    })
                )}
              </RouteSelectorBox>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={() => setDistsSubModalOpen(false)}
              >
                <FiCheckCircle /> Confirmar Distribuidores & Período
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {/* =====================================================================
          MODAL 4: CONFIGURAR SERVIDOR SMTP CRIPTOGRAFADO (ADMIN)
         ===================================================================== */}
      {smtpModalOpen && isAdmin && (
        <ModalOverlay onClick={() => setSmtpModalOpen(false)}>
          <ModalCard $maxWidth="620px" onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <div className="modal-title">
                <h3>
                  <FiServer /> Configurar Servidor SMTP (Criptografia AES-256-GCM)
                </h3>
                <span>
                  As credenciais são salvas criptografadas no banco de dados (dbo.GID_CONFIG_SMTP)
                </span>
              </div>
              <button
                type="button"
                className="close-btn"
                onClick={() => setSmtpModalOpen(false)}
              >
                <FiX />
              </button>
            </ModalHeader>

            <ModalBody>
              <FormRow>
                <FieldGroup>
                  <label>Servidor SMTP (Host)</label>
                  <StyledInput
                    type="text"
                    placeholder="Ex: smtp.gmail.com ou mail.grupogsa.com.br"
                    value={smtpHost}
                    onChange={(e) => setSmtpHost(e.target.value)}
                  />
                </FieldGroup>

                <FieldGroup>
                  <label>Porta SMTP</label>
                  <StyledInput
                    type="number"
                    placeholder="587 ou 465"
                    value={smtpPort}
                    onChange={(e) => {
                      const val = Number(e.target.value)
                      setSmtpPort(val)
                      if (val === 465) setSmtpSecure(true)
                      if (val === 587) setSmtpSecure(false)
                    }}
                  />
                </FieldGroup>
              </FormRow>

              <FormRow>
                <FieldGroup>
                  <label>Usuário / E-mail de Autenticação</label>
                  <StyledInput
                    type="email"
                    placeholder="notificacoes@grupogsa.com.br"
                    value={smtpUser}
                    onChange={(e) => setSmtpUser(e.target.value)}
                  />
                </FieldGroup>

                <FieldGroup>
                  <label>
                    Senha do SMTP {smtpHasPass && '(Já criptografada em banco)'}
                  </label>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <StyledInput
                      type={showSmtpPass ? 'text' : 'password'}
                      placeholder={
                        smtpHasPass
                          ? 'Deixe vazio para manter a senha criptografada atual'
                          : 'Digite a senha do SMTP'
                      }
                      value={smtpPass}
                      onChange={(e) => setSmtpPass(e.target.value)}
                    />
                    <ActionBtn
                      type="button"
                      $variant="secondary"
                      onClick={() => setShowSmtpPass(!showSmtpPass)}
                    >
                      {showSmtpPass ? <FiEyeOff /> : <FiEye />}
                    </ActionBtn>
                  </div>
                </FieldGroup>
              </FormRow>

              <FieldGroup>
                <label>Nome e E-mail do Remetente (From — Opcional)</label>
                <StyledInput
                  type="text"
                  placeholder="Ex: GID Relatórios <notificacoes@grupogsa.com.br>"
                  value={smtpFrom}
                  onChange={(e) => setSmtpFrom(e.target.value)}
                />
              </FieldGroup>

              <label
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                <input
                  type="checkbox"
                  checked={Number(smtpPort) === 465 ? true : smtpSecure && Number(smtpPort) !== 587}
                  onChange={(e) => setSmtpSecure(e.target.checked)}
                  style={{ width: 18, height: 18, accentColor: '#2563eb' }}
                />
                Conexão SSL/TLS direta (Ativa para porta 465; porta 587 utiliza STARTTLS automático)
              </label>
            </ModalBody>

            <ModalFooter>
              <ActionBtn
                type="button"
                $variant="secondary"
                onClick={() => setSmtpModalOpen(false)}
              >
                Cancelar
              </ActionBtn>
              <ActionBtn
                type="button"
                $variant="primary"
                onClick={handleSalvarSmtp}
                disabled={savingSmtp}
              >
                <FiLock />{' '}
                {savingSmtp
                  ? 'Criptografando e Salvando...'
                  : 'Salvar SMTP Criptografado em Banco'}
              </ActionBtn>
            </ModalFooter>
          </ModalCard>
        </ModalOverlay>
      )}

      {!onOpenUserSettings && (
        <ModalUserSettings
          isOpen={localSettingsOpen}
          onClose={() => setLocalSettingsOpen(false)}
        />
      )}
      {!onOpenWelcome && (
        <ModalWelcomeUpdate
          isOpen={localWelcomeOpen}
          onClose={() => setLocalWelcomeOpen(false)}
          onNavigate={() => {
            setLocalWelcomeOpen(false)
            handleBackToPanel()
          }}
        />
      )}
    </HubContainer>
  )
}

export default IntegrationsHub
